
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iE25L", function(module, exports) {
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $hI8o2 = parcelRequire("hI8o2");

function $ce6549af23056c33$var$decorateScope(scope, context) {
    const { tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $ce6549af23056c33$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    try {
        const sentryClient = await (0, $hI8o2.getSentryClient)();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            $ce6549af23056c33$var$decorateScope(scope, context);
            scope.setTag('name', name);
            scope.setTag('packageName', context.packageName ?? 'unknown');
            scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
            sentryClient.captureException(ex, scope);
        });
    } catch  {
    // silence sentry exceptions
    }
}
async function $ce6549af23056c33$var$logMessage(severity, message, context = {}) {
    const sentryClient = await (0, $hI8o2.getSentryClient)();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        $ce6549af23056c33$var$decorateScope(scope, context);
        // The Severity enum is being replaced by SeverityLevel type in v7 anyway
        // @ts-ignore - TypeScript 5.9.2 upgrade
        scope.setLevel(severity);
        scope.setTag('packageName', context.packageName ?? 'unknown');
        scope.setTag('packageVersion', context.packageVersion ?? 'unknown');
        sentryClient.captureMessage(message, scope);
    });
}
function $ce6549af23056c33$export$ece28f5cfa04608(message, context = {}) {
    $ce6549af23056c33$var$logMessage('error', message, context).catch(()=>{});
}
function $ce6549af23056c33$export$386587bcf05ee8ea(message, context = {}) {
    $ce6549af23056c33$var$logMessage('info', message, context).catch(()=>{});
}
const $ce6549af23056c33$export$9edc7d6f1c33ddc = (details)=>{
    return (error, message, tags = {})=>{
        $ce6549af23056c33$export$f86b2a1a2ce291b3(error, message, {
            tags: {
                ...details,
                ...tags
            }
        });
    };
};
const $ce6549af23056c33$export$7208e9272a946c36 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $ce6549af23056c33$export$f86b2a1a2ce291b3(args[0], args[1], {
            ...args[2],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $ce6549af23056c33$export$dbd2da61a76fb8d2 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $ce6549af23056c33$export$ece28f5cfa04608(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $ce6549af23056c33$export$f242834c5699e597 = (packageContext)=>(...args)=>{
        // Intentionally not awaiting the promise here as we don't need the result
        $ce6549af23056c33$export$386587bcf05ee8ea(args[0], {
            ...args[1],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
    };
const $ce6549af23056c33$export$6b2a307bf7c6c1dc = (packageContext)=>(...args)=>$ce6549af23056c33$export$9edc7d6f1c33ddc({
            ...args[0],
            packageName: packageContext.packageName,
            packageVersion: packageContext.packageVersion
        });
async function $ce6549af23056c33$export$efda9a273d7a036d(crumb) {
    const sentryClient = await (0, $hI8o2.getSentryClient)();
    sentryClient.withScope((scope)=>{
        // @ts-ignore - TypeScript 5.9.2 upgrade
        scope.addBreadcrumb(typeof crumb === 'string' ? {
            message: crumb
        } : crumb);
    });
}
module.exports["logException"] = $ce6549af23056c33$export$f86b2a1a2ce291b3;
module.exports["logErrorMessage"] = $ce6549af23056c33$export$ece28f5cfa04608;
module.exports["logInfoMessage"] = $ce6549af23056c33$export$386587bcf05ee8ea;
module.exports["logExceptionWithPackageContext"] = $ce6549af23056c33$export$7208e9272a946c36;
module.exports["logErrorMessageWithPackageContext"] = $ce6549af23056c33$export$dbd2da61a76fb8d2;
module.exports["logInfoMessageWithPackageContext"] = $ce6549af23056c33$export$f242834c5699e597;
module.exports["createErrorHandlerWithPackageContext"] = $ce6549af23056c33$export$6b2a307bf7c6c1dc;
module.exports["addBreadcrumb"] = $ce6549af23056c33$export$efda9a273d7a036d;

});

parcelRegister("hI8o2", function(module, exports) {
$parcel$export(module.exports, "sentryClient", () => $23add3463470039d$export$ac71c212168fcd2b);

var $lzcvT = parcelRequire("lzcvT");

const $7ca3bec1167570f5$export$9cf97fd92bea5d81 = '1dc056d49dfe4df8961dc1b810e4620d';
const $7ca3bec1167570f5$export$68c35ed3898e185a = '5988845';
const $7ca3bec1167570f5$export$b03be5cdb5af5197 = '067abcc494be9a87b3cdf9416f2b97d5';
const $7ca3bec1167570f5$export$97db6664a1e55fa6 = '47';
const $7ca3bec1167570f5$var$SENTRY_COMMERCIAL_DSN = `https://${$7ca3bec1167570f5$export$9cf97fd92bea5d81}@o55978.ingest.sentry.io/${$7ca3bec1167570f5$export$68c35ed3898e185a}`;
const $7ca3bec1167570f5$var$SENTRY_FEDRAMP_DSN = `https://${$7ca3bec1167570f5$export$b03be5cdb5af5197}@sentry.atlassian-us-gov-mod.com/${$7ca3bec1167570f5$export$97db6664a1e55fa6}`;
const $7ca3bec1167570f5$export$6faa4a850bc4d0ce = (0, $lzcvT.isFedRamp)() ? $7ca3bec1167570f5$var$SENTRY_FEDRAMP_DSN : $7ca3bec1167570f5$var$SENTRY_COMMERCIAL_DSN;



const $5cc1c03666c3d491$var$DEFAULT_SENTRY_CONFIG = {
    whitelistUrls: [
        /atl-paas.net/,
        // test local host
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/,
        // Network related errors
        'The operation was aborted',
        'Software caused connection abort',
        'GraphQL error: Failed to fetch',
        'TypeError: Failed to fetch',
        'TypeError: NetworkError when attempting to fetch resource.',
        'AbortError: The user aborted a request.',
        /^network error/i,
        /^network failure/i,
        /^NetworkError/i,
        /^Unexpected token ..*/
    ],
    ignoreUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i
    ],
    dsn: (0, $7ca3bec1167570f5$export$6faa4a850bc4d0ce),
    attachStacktrace: true
};
function $5cc1c03666c3d491$export$5580e6304e95c792(options) {
    const { env: env, version: version, noGlobals: _, ...otherOptions } = options;
    return {
        ...otherOptions,
        ...$5cc1c03666c3d491$var$DEFAULT_SENTRY_CONFIG,
        // Standalone __VERSION__ is set from `bin/set-release-version.sh`
        // when building to deploy to production
        release: `${"platform-pkg"}@${"0.0.0-use.local"}` || // @ts-ignore Jira  - window.BUILD_KEY
        window.BUILD_KEY || // @ts-ignore Confluence - window.__buildInfo
        window.__buildInfo?.FRONTEND_VERSION || '---',
        environment: env || 'prod'
    };
}



var $hI8o2 = parcelRequire("hI8o2");

const $df79019e7dc5b239$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
async function $df79019e7dc5b239$export$357606956af25316(client, options) {
    if (0, $hI8o2.sentryClient) return;
    if (!client) return;
    (0, $hI8o2.setSentryClient)(client);
    const sentryConfig = (0, $5cc1c03666c3d491$export$5580e6304e95c792)(options);
    (0, $hI8o2.sentryClient).init({
        ...sentryConfig,
        integrations: function(integrations) {
            return integrations.filter(function(integration) {
                return $df79019e7dc5b239$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        }
    });
}


let $23add3463470039d$export$ac71c212168fcd2b;
const $23add3463470039d$export$7d446c6f4e54de82 = (client)=>{
    $23add3463470039d$export$ac71c212168fcd2b = client;
};
const $23add3463470039d$export$f553e8b08ef59d31 = async ()=>{
    if (!$23add3463470039d$export$ac71c212168fcd2b) await $23add3463470039d$export$d8bd0edf6c978788({});
    return $23add3463470039d$export$ac71c212168fcd2b;
};
async function $23add3463470039d$export$d8bd0edf6c978788({ appName: appName, env: env }) {
    const sentryClient = await $23add3463470039d$var$requireSentryLib();
    if (!sentryClient) return;
    // initialiseSentry sets the sentry client
    (0, $df79019e7dc5b239$export$357606956af25316)(sentryClient, {
        initialScope: {
            tags: {
                renderMode: appName || 'unknown',
                productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                product: $23add3463470039d$var$getProduct()
            }
        },
        env: env,
        noGlobals: true,
        dsn: (0, $7ca3bec1167570f5$export$6faa4a850bc4d0ce),
        attachStacktrace: true
    });
}

async function $23add3463470039d$var$requireSentryLib() {
    // saving ~40K
    try {
        return (parcelRequire("5YDBG"));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Ignoring rejected promise when loading sentry resource.', error);
        return undefined;
    }
}
function $23add3463470039d$var$getProduct() {
    const path = window.location.pathname;
    if (path.includes('/jira/people')) return 'jira';
    else if (path.includes('/wiki/people')) return 'confluence';
    return 'unknown';
}
module.exports["setSentryClient"] = $23add3463470039d$export$7d446c6f4e54de82;
module.exports["getSentryClient"] = $23add3463470039d$export$f553e8b08ef59d31;
module.exports["setupSentryClient"] = $23add3463470039d$export$d8bd0edf6c978788;

});

parcelRegister("5YDBG", function(module, exports) {

let $45a147718811ee89$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $45a147718811ee89$var$load("7Omhy"),
    $45a147718811ee89$var$load("kC80R")
]).then(()=>parcelRequire('7hGsm'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("asH6r", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $iqaft = parcelRequire("iqaft");


var $4VXWT = parcelRequire("4VXWT");

const $dc5c4228ac2d2b6c$var$TeamsClientExperienceKeyList = [
    'getAllTeams',
    'getTeamById',
    'updateTeamById',
    'querySettings',
    'queryFeatureFlags',
    'queryTeamMemberships',
    'queryUser',
    'inviteUsersToTeam',
    'getMyTeamMembership',
    'getTeamLinksByTeamId',
    'createTeamLink',
    'updateTeamLink',
    'deleteTeamLink',
    'reorderTeamLink',
    'acceptTeamInvitation',
    'declineTeamInvitation',
    'selfJoinTeam',
    'cancelJoinRequest',
    'acceptJoinRequest',
    'declineJoinRequest',
    'deleteTeamMembership',
    'revokeTeamInvite',
    'deleteTeam',
    'archiveTeam',
    'unarchiveTeam',
    'unlinkTeamFromGroup',
    'isSingleFullMemberTeam',
    'createTeam',
    'createTeamContainers',
    'createExternalTeam',
    'getProfileWithMutability',
    'getIsSiteAdmin',
    'addUsersToTeam',
    'removeTeamMemberships',
    'getRecommendedProducts',
    'joinOrRequestDefaultAccessToProductsBulk',
    'getReadMediaToken',
    'getWriteUserMediaToken',
    'updateUserHeaderImage',
    'getWriteTeamMediaToken',
    'getSoftDeletedTeamById',
    'restoreTeam',
    'getUserInSiteUserBase',
    'getLinkedTeamsBulk',
    'getTeamProfileDetails',
    'getUserContainers',
    'getRecommendedUsers',
    'getPermissions',
    'getUserManageConfig',
    'getMyAvatarUploadedStatus',
    'deleteUserAvatar',
    'getTeamLinkIcons',
    'getTeamInSlack',
    'getOrgScope',
    'restoreTeamToSyncedGroup',
    'getTeamAndGroupDiff',
    'linkExistingTeamToGroup',
    'fetchUserAvatarInfo',
    'getOrgEligibilityForManagedTeams',
    'updateUser',
    'updateUserAvatar',
    'disconnectTeamInSlack',
    'updateTeamInSlack',
    'getUserTenure',
    'getAriFromUrl',
    'getWebLinkTitle',
    'addAgentToTeam',
    'getTeamEnabledSites',
    'assignTeamsToSites',
    'removeAgentTeamAssociation',
    'getAssignedTeams',
    'setTeamSiteAssignmentPermission',
    'getUnassignedTeams',
    'getTeamSiteAssignmentOrgDetails',
    'getTeamsToBeClonedToJsmSites',
    'getReportingLines'
];
const $dc5c4228ac2d2b6c$export$879344107b04120c = new Map([
    ...$dc5c4228ac2d2b6c$var$TeamsClientExperienceKeyList.map((key)=>[
            key,
            // camelCase to kebab-case
            new (0, $4VXWT.TeamsUFOExperience)(`teams-client-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`, {
                type: (0, $iqaft.ExperienceTypes).Operation,
                performanceType: (0, $iqaft.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'people'
                }
            })
        ])
]);



var $cFYtL = parcelRequire("cFYtL");


var $9qOkK = parcelRequire("9qOkK");





var $ftJwu = parcelRequire("ftJwu");


var $iE25L = parcelRequire("iE25L");

class $c438f55b6bac361e$export$4f22f74eddb7716a {
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || 'None'
        };
    }
    getContext() {
        return this.context;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
    constructor(config){
        this.config = void 0;
        this.context = void 0;
        this.cache = {};
        this.logException = (ex, name, context)=>{
            (0, $iE25L.logException)(ex, name, context);
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: 'None'
        };
    }
}






var $aR5ht = parcelRequire("aR5ht");

/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $038f3dc844c86bdc$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $038f3dc844c86bdc$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $038f3dc844c86bdc$export$8c005e458e12d501.handlers = handlers;
    }
};
function $038f3dc844c86bdc$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $038f3dc844c86bdc$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}


async function $9c09e9c92c77c779$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
            ...options.headers || {}
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $ftJwu.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((_resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $ftJwu.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $9c09e9c92c77c779$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $aR5ht.withExponentialBackoff)($9c09e9c92c77c779$export$93d33e3b46bf00e7, {
        initial: (0, $aR5ht.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $aR5ht.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $aR5ht.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $aR5ht.isFetchResponse)(data) && (0, $aR5ht.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $038f3dc844c86bdc$export$c113a67a6762ad2e)(response);
        if (status > 400 && status <= 599) throw new (0, $ftJwu.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}


class $f7f7d8f817036d9a$export$42f6d6baced34b2d extends (0, $c438f55b6bac361e$export$4f22f74eddb7716a) {
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    /**
   * Creates query context headers if cloudId is available and feature flag is enabled.
   */ createQueryContextHeaders(cloudId) {
        if (!cloudId || !(0, $dh538.fg)('enable_x_query_context_header')) return undefined;
        return {
            'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
        };
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            // Automatically add X-Query-Context header if cloudId is available in context
            const cloudId = this.getCloudId();
            const queryContextHeaders = this.createQueryContextHeaders(cloudId);
            // Merge headers: query context headers first, then provided headers (provided headers take precedence)
            const mergedOptions = {
                ...options,
                headers: {
                    ...queryContextHeaders,
                    ...options.headers
                }
            };
            return (0, $9c09e9c92c77c779$export$7feffc86760ee7ce)(this.serviceUrl, body, mergedOptions);
        } catch (error) {
            if (error instanceof (0, $ftJwu.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $ftJwu.DefaultError)({});
        }
    }
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = void 0;
        this.serviceUrl = serviceUrl;
    }
}






var $lB1H3 = parcelRequire("lB1H3");


var $eSUdr = parcelRequire("eSUdr");

const $a6844bd1f838af6a$export$74f3ccf149f124b = (0, $lB1H3.print)((0, $eSUdr.default)`mutation unlinkTeamToContainerMutation($teamId:ID!$containerId:ID!){graphStore@optIn(to:["GraphStoreMutation"]){deleteTeamConnectedToContainer(input:{relationships:[{from:$teamId to:$containerId}]})@optIn(to:["GraphStoreTeamConnectedToContainer"]){errors{message extensions{statusCode errorType}}success}}}`);








const $39077bba37ebb47a$export$6c9c309d551311e = (0, $lB1H3.print)((0, $eSUdr.default)`query getNumberOfTeamsForContainer($containerId:ID!){graphStore@optIn(to:"GraphStore"){teamConnectedToContainerInverse(id:$containerId consistentRead:true)@optIn(to:"GraphStoreTeamConnectedToContainer"){edges{id}}}}`);








const $c18c2fbd88e8327e$export$8e179b6008492526 = (0, $lB1H3.print)((0, $eSUdr.default)`query getTeamsForContainer($containerId:ID!){graphStore@optIn(to:"GraphStore"){teamConnectedToContainerInverse(id:$containerId consistentRead:true)@optIn(to:"GraphStoreTeamConnectedToContainer"){edges{node{...on TeamV2{id description displayName creator{id}smallAvatarImageUrl smallHeaderImageUrl largeAvatarImageUrl largeHeaderImageUrl members{nodes{member{id name picture accountStatus ...on AtlassianAccountUser{extendedProfile{jobTitle}}...on AppUser{appType}}role state}pageInfo{endCursor hasNextPage}}organizationId membershipSettings isVerified state}}}}}}`);








const $33bc95aad0ef09ed$export$dc2f639827051505 = (0, $lB1H3.print)((0, $eSUdr.default)`query TeamContainersQueryV2($cypherQuery:String!$params:JSON!){graphStore@optIn(to:["GraphStore" "GraphStoreCypherQueryV2"]){cypherQueryV2(query:$cypherQuery params:$params){edges{node{columns{key value{...on GraphStoreCypherQueryV2AriNode{data{__typename ...on ConfluenceSpace{id confluenceSpaceName:name type createdDate links{base webUi}icon{path}}...on JiraProject{id jiraProjectName:name webUrl created avatar{medium}projectType projectTypeName}...on LoomSpace{id loomSpaceName:name url}}}}}}}}}}`);








const $245e3358ba8a5cde$export$5a63c9c7b444f1f5 = (0, $lB1H3.print)((0, $eSUdr.default)`query serviceName_TeamHasAgentsQuery($id:ID!){graphStore@optIn(to:"GraphStore"){teamHasAgents(id:$id)@optIn(to:"GraphStoreTeamHasAgents"){edges{node{...on AppUser{id name picture}}cursor}pageInfo{hasNextPage endCursor}}}}`);


const $ff7514e3adb7f0c2$var$TeamMembershipQuery = `query app_user_characteristics($teamId: ID!, $siteId: String!, $membershipState: [TeamMembershipState!]!, $first: Int!, $after: String) {
    team {
      teamV2(
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        members(state: $membershipState, first: $first, after: $after) {
          edges {
            node {
              member {
                id
                name
                picture
                accountStatus
                ... on AtlassianAccountUser {
                  extendedProfile {
                    jobTitle
                  }
                }
                ... on AppUser {
                  appType
                }
              }
              role
              state
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }`;
var $ff7514e3adb7f0c2$export$2e2bcd8739ae039 = $ff7514e3adb7f0c2$var$TeamMembershipQuery;








const $aed4e59d41ac0da9$export$9963ed3cbf7b791c = (0, $lB1H3.print)((0, $eSUdr.default)`query TeamsUserQuery($userId:ID!){user(accountId:$userId){id name picture accountStatus __typename ...on AtlassianAccountUser{email nickname locale zoneinfo extendedProfile{jobTitle organization department location phoneNumbers{type value}closedDate inactiveDate}}...on CustomerUser{email locale zoneinfo}...on AppUser{appType}}}`);


function $e97a34dbb6762a3b$export$6b53fef091c7e27d({ isBot: isBot, appType: appType }) {
    // Note, the order of these checks is important
    if (appType?.toLocaleLowerCase() === 'agent') return 'agent';
    if (isBot) return 'bot';
    return 'user';
}


class $2e8ee8ab2bb7f77a$export$b44e5dafe13af7b3 extends (0, $f7f7d8f817036d9a$export$42f6d6baced34b2d) {
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        const response = await this.makeGraphQLRequest({
            query: (0, $ff7514e3adb7f0c2$export$2e2bcd8739ae039),
            variables: {
                teamId: teamId,
                membershipState: membershipState,
                siteId: this.getCloudId(),
                ...pageInfo
            }
        }, {
            operationName: 'TeamMembership'
        });
        return {
            edges: response.team.teamV2.members.edges.map(({ node: node })=>({
                    membershipId: {
                        teamId: teamId,
                        memberId: (0, $cFYtL.toUserId)(node.member.id)
                    },
                    state: node.state,
                    role: node.role,
                    user: {
                        id: (0, $cFYtL.toUserId)(node.member.id),
                        fullName: node.member.name,
                        avatarUrl: node.member.picture,
                        status: node.member.accountStatus,
                        title: node.member.extendedProfile?.jobTitle ?? undefined,
                        userType: (0, $e97a34dbb6762a3b$export$6b53fef091c7e27d)({
                            appType: node.member.appType
                        })
                    }
                })),
            pageInfo: response.team.teamV2.members.pageInfo
        };
    }
    async queryAGGUser(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $aed4e59d41ac0da9$export$9963ed3cbf7b791c),
            variables: {
                userId: userId
            }
        }, {
            operationName: 'TeamsUserQuery'
        });
        return response.user;
    }
    async queryTeamHasAgents(teamId) {
        const teamAri = (0, $cFYtL.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $245e3358ba8a5cde$export$5a63c9c7b444f1f5),
            variables: {
                id: teamAri
            }
        }, {
            operationName: 'TeamHasAgentsQuery'
        });
        return this.processTeamHasAgentsResponse(teamId, response.graphStore);
    }
    processTeamHasAgentsResponse(teamId, response) {
        return response.teamHasAgents.edges.map(({ node: node })=>({
                associationId: {
                    teamId: teamId,
                    accountId: (0, $cFYtL.toUserId)(node.id)
                },
                agent: {
                    id: node.id,
                    fullName: node.name,
                    avatarUrl: node.picture
                }
            }));
    }
    async getTeamContainers(teamId) {
        const teamAri = (0, $cFYtL.toTeamARI)(teamId);
        const cypherQuery = `MATCH (team:IdentityTeam {ari: '${teamAri}'})-[:team_connected_to_container]->(container) RETURN container`;
        const response = await this.makeGraphQLRequest({
            query: (0, $33bc95aad0ef09ed$export$dc2f639827051505),
            variables: {
                cypherQuery: cypherQuery,
                params: {
                    id: teamAri
                }
            }
        }, {
            operationName: 'TeamContainersQueryV2'
        });
        return this.processV2Response(response);
    }
    processV2Response(response) {
        const containersResult = response.graphStore.cypherQueryV2.edges.reduce((containers, edge)=>{
            edge.node.columns.forEach((column)=>{
                const containerData = column.value?.data;
                if (!containerData) return;
                if (containerData?.__typename === 'ConfluenceSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.confluenceSpaceName || '',
                    icon: `${containerData.links.base}${containerData.icon.path}`,
                    createdDate: new Date(containerData.createdDate),
                    link: `${containerData.links.base}${containerData.links.webUi}`,
                    containerTypeProperties: {
                        subType: undefined,
                        name: undefined
                    }
                });
                else if (containerData?.__typename === 'JiraProject') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.jiraProjectName,
                    icon: containerData.avatar.medium,
                    createdDate: new Date(containerData.created),
                    link: containerData.webUrl,
                    containerTypeProperties: {
                        subType: containerData.projectType || '',
                        name: containerData.projectTypeName || ''
                    }
                });
                else if (containerData?.__typename === 'LoomSpace') containers.push({
                    id: containerData.id,
                    type: containerData.__typename,
                    name: containerData.loomSpaceName,
                    icon: '',
                    link: containerData.url
                });
            });
            return containers;
        }, []);
        return containersResult;
    }
    async unlinkTeamContainer(teamId, containerId) {
        const teamAri = (0, $cFYtL.toTeamARI)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $a6844bd1f838af6a$export$74f3ccf149f124b),
            variables: {
                containerId: containerId,
                teamId: teamAri
            }
        }, {
            operationName: 'UnlinkContainerMutation'
        });
        return response.graphStore;
    }
    async queryNumberOfTeamConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $39077bba37ebb47a$export$6c9c309d551311e),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'NumberOfTeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.length;
    }
    async queryTeamsConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $c18c2fbd88e8327e$export$8e179b6008492526),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'TeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.map(({ node: node })=>({
                id: node.id,
                displayName: node.displayName,
                description: node.description,
                state: node.state,
                membershipSettings: node.membershipSettings,
                organizationId: node.organizationId,
                creatorId: node.creator?.id,
                isVerified: node.isVerified,
                members: node.members?.nodes.map(({ member: member })=>({
                        id: member?.id ? (0, $cFYtL.toUserId)(member?.id) : '',
                        fullName: member?.name ?? '',
                        avatarUrl: member?.picture,
                        status: member?.accountStatus
                    })) ?? [],
                includesYou: false,
                // to-do - this needs to be computed - https://product-fabric.atlassian.net/browse/CCECO-4368
                memberCount: node.members?.nodes.length ?? 0,
                largeAvatarImageUrl: node.largeAvatarImageUrl,
                smallAvatarImageUrl: node.smallAvatarImageUrl,
                largeHeaderImageUrl: node.largeHeaderImageUrl,
                smallHeaderImageUrl: node.smallHeaderImageUrl,
                restriction: 'ORG_MEMBERS' // deprecated field, kept for backwards compatibility
            }));
    }
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
}
const $2e8ee8ab2bb7f77a$export$464c991dbf0b2393 = new $2e8ee8ab2bb7f77a$export$b44e5dafe13af7b3((0, $9qOkK.DEFAULT_CONFIG).stargateRoot, {
    logException: $iE25L.logException
});






var $20sPA = parcelRequire("20sPA");









const $17fa690cff8febc6$export$f6101897f0230549 = 'redirectCount';
const $17fa690cff8febc6$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $17fa690cff8febc6$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $17fa690cff8febc6$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $17fa690cff8febc6$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}


async function $1a31bd719097cca3$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.error) return `${json.status || 'UNKNOWN_STATUS'} ${json.error || 'MISSING_ERROR_MESSAGE'}`;
    else if (json.status) return `${json.status} MISSING_ERROR_MESSAGE`;
    else if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || 'MISSING_ERROR_MESSAGE');
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}


function $9d84c6a1bfcec898$export$ba14d9a5a581e827(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}


const $6180865b54d7ecc7$var$UUID_REGEX = new RegExp(/((\w{4,12}-?)){5}/g);
const $6180865b54d7ecc7$export$6bd073e2c6dda996 = (path)=>{
    return path.replace($6180865b54d7ecc7$var$UUID_REGEX, '<UUID>');
};


const $d4429adef1b89b84$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
let $d4429adef1b89b84$var$incrementRedirectCount;
let $d4429adef1b89b84$var$clearRedirectCount;
$d4429adef1b89b84$export$7a0fc52d8c359feb();
function $d4429adef1b89b84$export$7a0fc52d8c359feb() {
    $d4429adef1b89b84$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($20sPA)))(()=>(0, $17fa690cff8febc6$export$110700823644f4a6)((0, $17fa690cff8febc6$export$f6101897f0230549), (0, $17fa690cff8febc6$export$6a289e5003f59269)((0, $17fa690cff8febc6$export$f6101897f0230549)) + 1));
    $d4429adef1b89b84$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($20sPA)))(()=>(0, $17fa690cff8febc6$export$ad3506281d5a5e5d)((0, $17fa690cff8febc6$export$f6101897f0230549)));
}
class $d4429adef1b89b84$export$ea8b5b3aea9558ce extends (0, $c438f55b6bac361e$export$4f22f74eddb7716a) {
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async getResource(path, fetchOptions = {}) {
        return this.makeRequest(path, fetchOptions);
    }
    async getResourceCached(path, fetchOptions = {}, cacheOptions) {
        const cacheKey = path;
        const cacheRecord = this.getCachedValue(cacheKey);
        if (cacheRecord) return cacheRecord;
        const response = await this.getResource(path, fetchOptions);
        this.cacheValue(cacheKey, response, cacheOptions?.expiration);
        return response;
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
       * PATCH must be uppercase as per fetch spec only
       * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
       * are normalised to uppercase.
       *
       * https://github.com/github/fetch/issues/37
       * https://fetch.spec.whatwg.org/#methods
       */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {
        shouldLogError: (e)=>e.status !== 429
    }) {
        const url = this.serviceUrl + path;
        const options = {
            ...$d4429adef1b89b84$var$defaultFetchOptions,
            ...additionalFetchOptions
        };
        const response = await (0, $aR5ht.fetchWithExponentialBackoff)(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $038f3dc844c86bdc$export$c113a67a6762ad2e)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $ftJwu.SLOIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await (0, $1a31bd719097cca3$export$91c32f1b22d29b2d)(response);
                const httpError = new (0, $ftJwu.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined,
                    path: path
                });
                if (options.shouldLogError && options.shouldLogError(httpError)) this.logException(httpError, (0, $6180865b54d7ecc7$export$6bd073e2c6dda996)(path), {
                    method: options.method || 'GET',
                    url: url,
                    status: responseStatusCode
                });
                throw httpError;
            }
        }
        // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
        return additionalFetchOptions.ignoreResponse ? null : (0, $9d84c6a1bfcec898$export$ba14d9a5a581e827)(response);
    }
    constructor({ serviceUrl: serviceUrl = '', config: config = {
        logException: ()=>{}
    } }){
        super(config);
        this.serviceUrl = void 0;
        /**
     * This function is necessary for if `statusCodeHandler` prescribes a login
     * redirect upon a 401 response.
     * While the default redirect behaviour may be overriden, this function has
     * been kept separate to ensure it cannot be overriden, lest a host
     * application supply embeddable-directory with a custom handler that suffers
     * the infinite redirect bug.
     */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $d4429adef1b89b84$var$incrementRedirectCount();
            } else $d4429adef1b89b84$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
}


var $bba3dd522b653c17$var$CONTAINER_TYPE = /*#__PURE__*/ function(CONTAINER_TYPE) {
    CONTAINER_TYPE["JIRA_PROJECT"] = "jiraProject";
    CONTAINER_TYPE["CONFLUENCE_SPACE"] = "confluenceSpace";
    return CONTAINER_TYPE;
}($bba3dd522b653c17$var$CONTAINER_TYPE || {});
var $bba3dd522b653c17$var$ENTITY_TYPE = /*#__PURE__*/ function(ENTITY_TYPE) {
    ENTITY_TYPE["CONTAINER"] = "CONTAINER";
    ENTITY_TYPE["USER"] = "USER";
    return ENTITY_TYPE;
}($bba3dd522b653c17$var$ENTITY_TYPE || {});
class $bba3dd522b653c17$export$cd5b4a06db0ea4e2 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    getUserContainers({ userId: userId, principalId: principalId, siteId: siteId, sessionId: sessionId, maxNumberOfResults: maxNumberOfResults }) {
        return this.postResource('/v1/collaborationgraph/user/container', {
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        });
    }
    getRecommendedUsers({ accountId: accountId, cloudId: cloudId, maxNumberOfResults: maxNumberOfResults = 12, filter: filter = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:"app")' }) {
        return this.postResource('/v2/recommend/user', {
            context: {
                userId: accountId,
                tenantId: cloudId
            },
            modelRequestParams: {
                experience: 'CgUserNearbyUser',
                caller: 'atlas'
            },
            requestingUserId: accountId,
            expand: 'existing',
            maxNumberOfResults: maxNumberOfResults,
            filter: filter
        });
    }
}
var $bba3dd522b653c17$export$2e2bcd8739ae039 = new $bba3dd522b653c17$export$cd5b4a06db0ea4e2({
    serviceUrl: (0, $9qOkK.DEFAULT_CONFIG).collaborationGraphUrl
});









const $fecffb0f2c6ffe55$export$28456d095a642fd = 'internal.browse-users-allowed';
const $fecffb0f2c6ffe55$var$buildTeamMembershipQuery = (teamId, membershipState)=>({
        query: `query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {
    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {
      user: profile {
        id,
        fullName,
        title,
        avatarUrl,
        timezone,
        status
      },
      state:membershipStatus,
      role,
      membershipId {
        teamId, memberId
      }
    }
  }`,
        variables: {
            teamId: teamId,
            membershipState: membershipState
        }
    });
const $fecffb0f2c6ffe55$var$buildUserQuery = (userId, cloudId)=>({
        query: `query CloudUser($userId: String!, $cloudId: String!) {
    CloudUser(userId: $userId, cloudId: $cloudId) {
      avatarUrl
      id
      fullName
      title
    }
  }`,
        variables: {
            userId: userId,
            cloudId: cloudId
        }
    });
const $fecffb0f2c6ffe55$var$delay = (millis)=>new Promise((resolve)=>{
        setTimeout(resolve, millis);
    });
class $fecffb0f2c6ffe55$export$c8a50bf6c196fc10 extends (0, $f7f7d8f817036d9a$export$42f6d6baced34b2d) {
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/directory/graphql`);
    }
    async queryFeatureFlags(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId, flags) {
        const queryFeatureFlags = {
            query: `query FeatureFlags($cloudId: String!, $flags: [String]!) {
        FeatureFlags(cloudId: $cloudId, flags: $flags) {
          flag
          enabled
        }
      }`,
            variables: {
                cloudId: this.getCloudId(cloudId),
                flags: flags
            }
        };
        const { FeatureFlags: FeatureFlags } = await this.makeGraphQLRequest(queryFeatureFlags, {
            operationName: 'FeatureFlags'
        });
        return FeatureFlags.map(({ flag: flag, enabled: enabled })=>[
                flag,
                enabled
            ]).reduce((acc, val)=>(acc[val[0]] = val[1], acc), {});
    }
    canRetryError(pendingRetries, error) {
        return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
    }
    /**
   * Get user information of all members of a team
   * @param {string} teamId
   * @returns {Promise}
   * @private
   * @deprecated use AGG instead
   */ queryTeamMemberships(teamId, membershipStatus = [
        'FULL_MEMBER'
    ]) {
        // eslint-disable-next-line no-console
        console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
        const teamMembershipsQuery = $fecffb0f2c6ffe55$var$buildTeamMembershipQuery(teamId, membershipStatus);
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(teamMembershipsQuery, {
                    operationName: 'TeamMembership'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $fecffb0f2c6ffe55$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest().then(({ TeamMembership: TeamMembership })=>TeamMembership);
    }
    /**
   * Get user information of all members of a team
   * @param {string} userId
   * @returns {Promise}
   */ queryUser(userId, /**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        const userQuery = $fecffb0f2c6ffe55$var$buildUserQuery(userId, this.getCloudId(cloudId));
        const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000)=>{
            try {
                return await this.makeGraphQLRequest(userQuery, {
                    operationName: 'CloudUser'
                });
            } catch (error) {
                if (this.canRetryError(pendingRetries, error)) {
                    await $fecffb0f2c6ffe55$var$delay(backoffMaxDelay / pendingRetries);
                    return performRequest(pendingRetries - 1);
                }
                throw error;
            }
        };
        return performRequest();
    }
    constructor(baseUrl, config){
        super(`${baseUrl}/directory/graphql`, config);
    }
}
const $fecffb0f2c6ffe55$export$ead519165de472de = new $fecffb0f2c6ffe55$export$c8a50bf6c196fc10((0, $9qOkK.DEFAULT_CONFIG).stargateRoot, {
    logException: $iE25L.logException
});







var $3Vbz9 = parcelRequire("3Vbz9");

// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $30abbd997ca0dfc8$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $30abbd997ca0dfc8$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $30abbd997ca0dfc8$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $3Vbz9.formatInTimeZone)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($30abbd997ca0dfc8$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($30abbd997ca0dfc8$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$30abbd997ca0dfc8$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($30abbd997ca0dfc8$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($30abbd997ca0dfc8$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$30abbd997ca0dfc8$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
var $30abbd997ca0dfc8$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
const $30abbd997ca0dfc8$export$78158d2c2c6998d9 = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $30abbd997ca0dfc8$export$2ff7b92b9e1bb4d2 = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $30abbd997ca0dfc8$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $30abbd997ca0dfc8$export$2ff7b92b9e1bb4d2[field]) return data[$30abbd997ca0dfc8$export$2ff7b92b9e1bb4d2[field]];
    const mappedFieldKey = field in $30abbd997ca0dfc8$export$78158d2c2c6998d9 ? $30abbd997ca0dfc8$export$78158d2c2c6998d9[field] : undefined;
    if (!mappedFieldKey) return undefined;
    const profileWrite = data['profile.write'];
    return profileWrite[mappedFieldKey];
};
const $30abbd997ca0dfc8$var$convertFieldKeyToFieldType = (key)=>{
    // Check if the key can be mapped to a FieldType value
    if (Object.values($30abbd997ca0dfc8$export$ed12481c953b8653).includes(key)) return key;
    return undefined;
};
const $30abbd997ca0dfc8$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $30abbd997ca0dfc8$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return undefined;
    const convertedField = $30abbd997ca0dfc8$var$convertFieldKeyToFieldType(field);
    if (!convertedField) return undefined;
    const reason = fieldConfig.reason;
    return {
        field: convertedField,
        reason: reason && reason.key || null
    };
};
const $30abbd997ca0dfc8$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($30abbd997ca0dfc8$export$78158d2c2c6998d9).map((field)=>$30abbd997ca0dfc8$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== undefined)
    });
const $30abbd997ca0dfc8$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($30abbd997ca0dfc8$var$PROFILE_PROPS_MAP.has(key)) output[$30abbd997ca0dfc8$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($30abbd997ca0dfc8$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$30abbd997ca0dfc8$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};
function $30abbd997ca0dfc8$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}


const $c928023e423fd9b8$var$defaultConfig = {
    serviceUrl: `${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}/users`
};
class $c928023e423fd9b8$export$f9c003efee04f318 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async getUserManageConfig(userId) {
        return this.getResourceCached(`/${userId}/manage`).then((resp)=>{
            return (0, $30abbd997ca0dfc8$export$d7725d3d27b80a68)(resp);
        });
    }
    /**
   * @deprecated
   * User fetchUserAvatarInfo instead
   */ async getMyAvatarUploadedStatus(userId) {
        return this.fetchUserAvatarInfo(userId);
    }
    async deleteAvatar(userId) {
        return this.deleteResource(`/${userId}/manage/avatar`);
    }
    async fetchUserAvatarInfo(userId) {
        return this.getResource(`/${userId}/manage/avatar`);
    }
    async updateUser({ id: id, ...user }) {
        return this.patchResource(`/${id}/manage/profile`, (0, $30abbd997ca0dfc8$export$7b103107c889cb67)(user));
    }
    async updateUserAvatar({ id: id, fileURI: fileURI }) {
        const fileObject = (0, $30abbd997ca0dfc8$export$80d19edb7b1ae293)(fileURI);
        const formData = new FormData();
        formData.append('file', fileObject);
        const response = await this.makeRequest(`/${id}/manage/avatar`, {
            method: 'PUT',
            body: formData
        });
        return response.url;
    }
    constructor(config = {}){
        super({
            ...$c928023e423fd9b8$var$defaultConfig,
            ...config
        });
    }
}
var $c928023e423fd9b8$export$2e2bcd8739ae039 = new $c928023e423fd9b8$export$f9c003efee04f318();









/**
 * Determines which capability is more desirable.
 * Users desire direct access over request access since it's instant.
 * @returns 0 if equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $88988132b69511f5$var$compareCapability = (a, b)=>{
    if (a === b) return 0;
    return a === 'DIRECT_ACCESS' ? -1 : 1;
};
/**
 * Determines which mode is more desirable.
 * Atlassian prefers to provide open access over domain restricted access.
 * Both of these modes have already been enabled by an admin.
 * If mode is undefined, it is deemed least desirable.
 * @returns 0 if equal, -1 if a is more open, 1 if b is more open.
 */ const $88988132b69511f5$var$compareMode = (a, b)=>{
    if (a === b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a === 'OPEN' ? -1 : 1;
};
/**
 * Determine if a recommendation is more desirable than another.
 * Atlassian prefers a better capability over any mode setting.
 * The mode will only be compared if the capabilities are equal.
 * If both capability and mode are equal, the recommendations are considered the same.
 *
 * Assumes recommendations have the same resource ID.
 * Do not compare recommendations with different resource IDs, as it does not make sense.
 *
 * @returns 0 if capability and mode are equal, -1 if a is more desirable, 1 if b is more desirable.
 */ const $88988132b69511f5$var$compareRecommendations = (a, b)=>{
    if (a.resourceId !== b.resourceId) throw new Error('Recommendations must have the same resource ID');
    if ($88988132b69511f5$var$compareCapability(a.capability, b.capability) < 0) return -1;
    else if ($88988132b69511f5$var$compareCapability(a.capability, b.capability) > 0) return 1;
    else if ($88988132b69511f5$var$compareMode(a.mode, b.mode) < 0) return -1;
    else if ($88988132b69511f5$var$compareMode(a.mode, b.mode) > 0) return 1;
    return 0;
};
const $88988132b69511f5$var$toRecommendation = (recommendation)=>{
    const { capability: capability, ...rest } = recommendation;
    return {
        ...rest
    };
};
const $88988132b69511f5$export$d9d1c981635dd213 = (recommendations)=>{
    const { DIRECT_ACCESS: DIRECT_ACCESS, REQUEST_ACCESS: REQUEST_ACCESS } = recommendations.capability;
    const uniqueRecommendations = {};
    const allRecommendations = [
        ...DIRECT_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'DIRECT_ACCESS'
            })),
        ...REQUEST_ACCESS.map((recommendation)=>({
                ...recommendation,
                capability: 'REQUEST_ACCESS'
            }))
    ];
    allRecommendations.forEach((recommendation)=>{
        const existing = uniqueRecommendations[recommendation.resourceId];
        if (existing && $88988132b69511f5$var$compareRecommendations(existing, recommendation) <= 0) return;
        uniqueRecommendations[recommendation.resourceId] = recommendation;
    });
    const allUniqueRecommendations = Object.values(uniqueRecommendations);
    return {
        capability: {
            DIRECT_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'DIRECT_ACCESS').map($88988132b69511f5$var$toRecommendation),
            REQUEST_ACCESS: allUniqueRecommendations.filter((recommendation)=>recommendation.capability === 'REQUEST_ACCESS').map($88988132b69511f5$var$toRecommendation)
        }
    };
};


const $87f3561bb905741b$var$PRODUCT_RECCOMENDATIONS = '/v1/product-recommendations';
const $87f3561bb905741b$var$PRODUCT_JOIN_OR_REQUEST_BULK = '/v1/access-requests/bulk/request';
const $87f3561bb905741b$var$ALL_SUPPORTED_PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-servicedesk',
    'jira-software',
    'jira-incident-manager',
    'jira-product-discovery',
    'opsgenie',
    'statuspage',
    'avocado',
    'townsquare',
    'compass',
    'avp',
    'beacon',
    'mercury'
];
class $87f3561bb905741b$export$3209eb31343f39d extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async getProductRecommendationsInner(supportedProducts = $87f3561bb905741b$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        try {
            const orgId = this.getOrgId();
            const queryProducts = supportedProducts && supportedProducts.length > 0 ? supportedProducts : $87f3561bb905741b$var$ALL_SUPPORTED_PRODUCTS;
            const productQueryParams = queryProducts.map((product)=>`product=${product}`).join('&');
            const capabilityQueryParams = capabilities && capabilities.length > 0 ? '&' + capabilities.map((capability)=>`capability=${capability}`).join('&') : '';
            const url = `${$87f3561bb905741b$var$PRODUCT_RECCOMENDATIONS}?orgId=${orgId}&${productQueryParams}${capabilityQueryParams}`;
            return await this.getResource(url);
        } catch (error) {
            this.logException(error, 'An error occurred while getting product recommendations.');
            throw error;
        }
    }
    async getProductRecommendations(supportedProducts = $87f3561bb905741b$var$ALL_SUPPORTED_PRODUCTS, capabilities) {
        // This endpoint may return duplicate resource ARIs with a different mode.
        const result = await this.getProductRecommendationsInner(supportedProducts, capabilities);
        try {
            const deduplicatedResult = (0, $88988132b69511f5$export$d9d1c981635dd213)(result);
            return deduplicatedResult;
        } catch (error) {
            this.logException(error, 'An error occurred while deduplicating product recommendations.');
            throw error;
        }
    }
    async joinOrRequestDefaultAccessToProductsBulk(simplifiedRequest) {
        if (simplifiedRequest.productAris.length === 0) return Promise.resolve([]);
        try {
            const resources = simplifiedRequest.productAris.map((ari)=>({
                    ari: ari,
                    role: 'product/member'
                }));
            const request = {
                resources: resources,
                note: simplifiedRequest.note,
                accessMode: simplifiedRequest.accessMode,
                source: simplifiedRequest.source
            };
            return await this.postResource($87f3561bb905741b$var$PRODUCT_JOIN_OR_REQUEST_BULK, request);
        } catch (error) {
            this.logException(error, 'An error occurred while joining or requesting access to products.');
            throw error;
        }
    }
    constructor(serviceUrl, config){
        super({
            serviceUrl: serviceUrl,
            config: config
        });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$87f3561bb905741b$export$2e2bcd8739ae039 = new $87f3561bb905741b$export$3209eb31343f39d((0, $9qOkK.DEFAULT_CONFIG).invitationsServiceUrl, {
    logException: $iE25L.logException
});






const $870a7b5ea18ac45b$var$v3UrlPath = `/v3/teams`;
const $870a7b5ea18ac45b$var$v4UrlPath = `/v4/teams`;
class $870a7b5ea18ac45b$export$68a6a391e3cf23be extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    setRootUrl(url) {
        if (url === this.serviceUrlRoot) return;
        this.serviceUrlRoot = url;
        this.setServiceUrl(url);
    }
    async getTeamById(teamId, cloudId) {
        const siteId = this.getCloudId(cloudId);
        const teamResponse = await this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}?siteId=${siteId}`);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    async getAllTeams(allTeamsQuery) {
        try {
            const orgId = this.getOrgId(allTeamsQuery.orgId);
            const siteId = this.getCloudId();
            const { entities: entities, cursor: cursor } = await this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/search`, {
                organizationId: orgId,
                siteId: siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : allTeamsQuery.sortBy && allTeamsQuery.sortBy.length > 0 ? allTeamsQuery.sortBy : [
                    {
                        field: 'displayName',
                        order: 'asc'
                    }
                ],
                membership: {
                    memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams,
                teamTypeIdsFilter: allTeamsQuery.teamTypeIdsFilter
            });
            const teams = entities.map((t)=>this.mapTeamSearchResponseV4ToTeamWithMembership(t));
            return {
                cursor: cursor,
                teams: teams
            };
        } catch (error) {
            this.logException(error, 'getAllTeams');
            return {
                cursor: '',
                teams: [],
                error: error instanceof Error ? error : undefined
            };
        }
    }
    async updateTeamById(teamId, data) {
        const teamResponse = await this.patchResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, data);
        return this.mapTeamResponseV4ToTeam(teamResponse);
    }
    /**
   * @private
   * @deprecated use publicApiClient.addUsersToTeam instead
   */ async inviteUsersToTeam(teamId, users, originQuery) {
        if (!users || users.length === 0) return Promise.resolve([]);
        const emails = [];
        const ids = [];
        users.forEach((user)=>{
            if (user.id) ids.push(user.id);
            else if (user.email) emails.push(user.email);
        });
        const url = `${$870a7b5ea18ac45b$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/invite?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url, {
            emailAddresses: emails,
            atlassianAccounts: ids
        });
    }
    async getMyTeamMembership(teamId) {
        return this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/me?siteId=${this.getCloudId()}`, {
            shouldLogError: (e)=>e.status !== 400
        });
    }
    async getTeamLinksByTeamId(teamId) {
        let siteId = this.getCloudId();
        let response = await this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links?siteId=${siteId}`);
        return this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response);
    }
    async createTeamLink(teamId, link) {
        const sanitisedTeamLink = {
            contentTitle: link.contentTitle.trim(),
            linkUri: link.linkUri.trim(),
            description: link.description.trim(),
            ...link.creationTime ? {
                creationTime: link.creationTime.trim()
            } : {},
            ...link.teamId ? {
                teamId: link.teamId.trim()
            } : {}
        };
        const response = await this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links`, sanitisedTeamLink);
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async updateTeamLink(teamId, linkId, { linkUri: linkUri, ...linkFields }) {
        const response = await this.putResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`, {
            linkUri: linkUri.trim(),
            ...linkFields
        });
        return this.mapLegionTeamLinkResponseV4ToTeamLink(response);
    }
    async deleteTeamLink(teamId, linkId) {
        return this.deleteResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/${linkId}`);
    }
    async reorderTeamLink(teamId, linkId, newPosition) {
        const queryArgs = `?linkId=${linkId}&newPosition=${newPosition}`;
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/links/order${queryArgs}`);
    }
    async getOrgEligibilityForManagedTeams() {
        const orgId = this.getOrgId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgEligibilityForManagedTeams');
            throw err;
        }
        return this.getResourceCached(`${$870a7b5ea18ac45b$var$v4UrlPath}/org/${orgId}/premium/eligibility`);
    }
    /**
   * @private
   * @deprecated in V4, as no invitation status for team membership anymore.
   */ async acceptTeamInvitation(teamId) {
        return this.postResource(`${$870a7b5ea18ac45b$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/accept`);
    }
    /**
   * @private
   * @deprecated in V4, as no invitation status for team membership anymore.
   */ async declineTeamInvitation(teamId) {
        return this.postResource(`${$870a7b5ea18ac45b$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/decline`);
    }
    async selfJoinTeam(// TODO Test me
    teamId, originQuery) {
        const url = `${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/join?${this.constructProductOriginParams(originQuery)}`;
        return this.postResource(url);
    }
    async addAgentsToTeam(teamId, agents) {
        if (!agents || agents.length === 0) {
            const missingAgentsError = new Error('Missing agents to add');
            this.logException(missingAgentsError, 'addAgentToTeam');
            throw missingAgentsError;
        }
        try {
            const url = `${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents`;
            return this.postResource(url, {
                agents: agents
            });
        } catch (e) {
            this.logException(e, 'addAgentToTeam');
            throw e;
        }
    }
    async removeAgentTeamAssociation(teamId, agentId) {
        try {
            const url = `${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/agents/${agentId}`;
            return this.deleteResource(url);
        } catch (e) {
            this.logException(e, 'removeAgentTeamAssociation');
            throw e;
        }
    }
    async cancelJoinRequest(teamId) {
        return this.deleteResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/request`);
    }
    async acceptJoinRequest(teamId, memberId) {
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/accept`);
    }
    async declineJoinRequest(teamId, memberId) {
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/membership/${memberId}/request/decline`);
    }
    /**
   * @private
   * @deprecated use publicApiClient.removeTeamMemberships instead
   */ async deleteTeamMembership(teamId, memberId) {
        return this.deleteResource(`${$870a7b5ea18ac45b$var$v3UrlPath}/${this.trimTeamARI(teamId)}/members/${memberId}`);
    }
    /**
   * @private
   * @deprecated INVITED status has been deprecated
   */ async revokeTeamInvite(teamId, memberId) {
        return this.deleteResource(`${$870a7b5ea18ac45b$var$v3UrlPath}/ui/${this.trimTeamARI(teamId)}/membership/${memberId}/revoke`);
    }
    async deleteTeam(teamId) {
        return this.deleteResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}`);
    }
    async archiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/archive?siteId=${siteId}`);
    }
    async unArchiveTeam(teamId) {
        const siteId = this.getCloudId();
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/unarchive?siteId=${siteId}`);
    }
    async unlinkTeamFromGroup(teamId, membershipSettings) {
        return this.patchResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}`, {
            membershipSettings: membershipSettings
        });
    }
    /**
   * @private
   * @deprecated should be other means to solve this issue
   */ async isSingleFullMemberTeam(teamId) {
        // This is still not working...
        const members = await this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/members?size=2&membershipState=FULL_MEMBER&siteId=${this.getCloudId()}`);
        return members.entities.length === 1;
    }
    async createTeam(displayName, originQuery, members, membershipSettings = 'OPEN', typeId) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$870a7b5ea18ac45b$var$v4UrlPath}?${this.constructProductOriginParams(originQuery)}`;
        const legionTeam = await this.postResource(url, {
            displayName: displayName,
            description: '',
            membershipSettings: membershipSettings,
            siteId: this.getCloudId(),
            organizationId: organizationId,
            members: [
                ...new Set(members)
            ],
            typeId: typeId
        });
        return this.mapTeamCreateResponseV4ToTeam(legionTeam);
    }
    async createExternalTeam(description, externalReference, teamName, siteId) {
        const organizationId = this.getContext().orgId;
        const cloudId = this.getContext().cloudId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'createTeam');
            throw err;
        }
        const url = `${$870a7b5ea18ac45b$var$v4UrlPath}/external?origin.cloudId=${encodeURIComponent(this.getCloudId(siteId || cloudId))}`;
        const legionExternalTeam = await this.postResource(url, {
            description: description,
            externalReference: externalReference,
            organizationId: organizationId,
            siteId: siteId || cloudId,
            displayName: teamName
        });
        return this.mapTeamCreateResponseV4ToTeam(legionExternalTeam);
    }
    async getTeamAndGroupDiff(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/diff`, {
            siteId: siteId,
            externalReference: externalReference
        });
    }
    async linkExistingTeamToGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${this.trimTeamARI(teamId)}/external/link`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async getWriteMediaToken() {
        return this.getResource('/v4/teams/header-image/media-upload').then((response)=>({
                ...response,
                baseUrl: response.baseUrl?.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
            }));
    }
    async getSoftDeletedTeamById(teamId) {
        const orgId = this.getOrgId();
        const siteId = this.getCloudId();
        return this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/org/${orgId}/soft-deleted/${this.trimTeamARI(teamId)}?siteId=${siteId}`).then((response)=>({
                ...response.teamResponse,
                id: teamId
            }));
    }
    /**
   * Shoud only be used within Teams (P&T) packages
   */ async getUserInSiteUserBase(userId) {
        const siteId = this.getCloudId();
        return this.getResource(`/teams/site/${siteId}/users/${userId}/exists`, {
            headers: {
                Accept: 'application/json',
                'X-header-client-id': 'ptc-fe'
            }
        });
    }
    async retrieveBrowseUserPermission(product) {
        return this.getResourceCached(`/teams/site/${this.getCloudId()}/canSearchUsers?product=${product}`, undefined, // 2 minute expiration, resolves duplicate calls in initial load
        {
            expiration: 120000
        });
    }
    async getPermissions() {
        const orgId = this.getContext().orgId;
        const siteId = this.getCloudId();
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getPermissions');
            throw err;
        }
        return this.getResourceCached(`${$870a7b5ea18ac45b$var$v4UrlPath}/permission/self/organization/${orgId}?siteId=${siteId}`);
    }
    async getLinkedTeamsBulk(groupIds) {
        const organizationId = this.getContext().orgId;
        if (!organizationId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getLinkedTeamsBulk');
            throw err;
        }
        const legionExternalTeam = await this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/external/bulk`, {
            organizationId: organizationId,
            source: 'ATLASSIAN_GROUP',
            externalIds: groupIds
        });
        return legionExternalTeam;
    }
    async getTeamProfileDetails(teamId, siteId) {
        const finalSiteId = siteId || this.getCloudId();
        if (!finalSiteId) {
            const err = new Error('Site ID is required');
            this.logException(err, 'getTeamProfileDetails');
            throw err;
        }
        const linkedTeamsProfileDetails = await this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${teamId}/profile?siteId=${finalSiteId}`);
        return linkedTeamsProfileDetails;
    }
    async getOrgScope() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getOrgScope');
            throw err;
        }
        const orgScope = await this.getResourceCached(`${$870a7b5ea18ac45b$var$v4UrlPath}/org/${orgId}/scope`);
        return orgScope;
    }
    async restoreTeamToSyncedGroup(teamId, externalReference) {
        const siteId = this.getCloudId();
        return await this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/${teamId}/external/restore`, {
            externalReference: externalReference,
            siteId: siteId
        });
    }
    async createTeamContainers(payload) {
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/containers`, {
            ...payload
        });
    }
    async getTeamEnabledSites(teamId) {
        const teamEnabledSites = await this.getResourceCached(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope/${teamId}`);
        return teamEnabledSites;
    }
    async assignTeamsToSites(migrations) {
        const assignTeamsToSitesResponse = await this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope`, {
            originOrgId: this.getContext().orgId,
            migrations: migrations
        });
        return assignTeamsToSitesResponse;
    }
    async getTeamsToBeClonedToJsmSites(teamsToSiteScope) {
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope/review`, {
            orgId: this.getContext().orgId,
            teamsToSiteScope: teamsToSiteScope
        });
    }
    async setTeamSiteAssignmentPermission(orgId, alignmentPermission) {
        return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope/permissions`, {
            orgId: orgId,
            alignmentPermission: alignmentPermission
        });
    }
    async getAssignedTeams(orgId, count, cursor, displayNameContains) {
        const assignedTeamsResponse = await this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope/aligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            displayNameContains: displayNameContains
        });
        return assignedTeamsResponse;
    }
    async getUnassignedTeams(orgId, count, cursor, query) {
        const unassignedTeamsResponse = await this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope/unaligned/search`, {
            orgId: orgId,
            count: count,
            cursor: cursor,
            query: query
        });
        return unassignedTeamsResponse;
    }
    async getTeamSiteAssignmentOrgDetails() {
        const orgId = this.getContext().orgId;
        if (!orgId) {
            const err = new Error('Organization ID is required');
            this.logException(err, 'getTeamSiteAssignmentOrgDetails');
            throw err;
        }
        return this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope/details/${orgId}`);
    }
    // some Legion APIs return team id with the team ARI
    trimTeamARI(teamId = '') {
        const OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
        const TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
        return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
    constructProductOriginParams(originQuery) {
        const product = (originQuery.product || '').toUpperCase();
        const queries = [
            `origin.cloudId=${encodeURIComponent(this.getCloudId(originQuery.cloudId))}`
        ];
        if (product) queries.push(`origin.product=${encodeURIComponent(product)}`);
        return queries.join('&');
    }
    mapTeamResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            scopeMode: teamResponse.scopeMode,
            isVerified: teamResponse.isVerified,
            ...teamResponse.externalReference && {
                externalReference: {
                    id: teamResponse.externalReference.id,
                    source: teamResponse.externalReference.source
                }
            }
        };
    }
    mapTeamCreateResponseV4ToTeam(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            creatorId: teamResponse.creatorId,
            permission: teamResponse.permission,
            orgId: teamResponse.organizationId,
            memberIds: teamResponse.membership?.members?.map((m)=>m.membershipId.memberId) || [],
            membership: teamResponse.membership
        };
    }
    mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
        return {
            id: teamResponse.id,
            displayName: teamResponse.displayName,
            description: teamResponse.description,
            state: teamResponse.state,
            membershipSettings: teamResponse.membershipSettings,
            organizationId: teamResponse.organizationId,
            restriction: 'ORG_MEMBERS',
            // Deprecated field, not used in UI - this is the safest default
            smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
            largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
            smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
            largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
            memberCount: teamResponse.memberCount,
            includesYou: teamResponse.includesYou,
            memberIds: [],
            // Team Search API does not return members
            members: [],
            // Team Search API does not return members
            membership: {
                members: [],
                errors: []
            },
            isVerified: teamResponse.isVerified
        };
    }
    mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
        };
    }
    mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
        return {
            entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
        };
    }
    mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
        return {
            contentTitle: legionLinkResponseV3.contentTitle,
            description: legionLinkResponseV3.description,
            creationTime: legionLinkResponseV3.creationTime,
            linkUri: legionLinkResponseV3.linkUri,
            linkId: legionLinkResponseV3.linkId,
            teamId: legionLinkResponseV3.teamId
        };
    }
    mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
        return {
            contentTitle: legionLinkResponseV4.contentTitle,
            description: legionLinkResponseV4.description,
            linkUri: legionLinkResponseV4.linkUri,
            linkId: legionLinkResponseV4.linkId,
            teamId: legionLinkResponseV4.teamId
        };
    }
    checkOrgFullAlignmentStatus(orgId) {
        try {
            return this.getResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/migrations/scope/${orgId}/fully-aligned`);
        } catch (e) {
            this.logException(e, 'checkOrgFullAlignmentStatus');
            throw e;
        }
    }
    async getTeamStatesInBulk(orgId, teamIds) {
        try {
            return this.postResource(`${$870a7b5ea18ac45b$var$v4UrlPath}/adminhub/states/bulk`, {
                orgId: orgId,
                teamIds: teamIds
            });
        } catch (e) {
            this.logException(e, 'getTeamStatesInBulk');
            throw e;
        }
    }
    constructor(serviceUrl){
        super({
            serviceUrl: serviceUrl
        });
        this.serviceUrlRoot = void 0;
        this.serviceUrlRoot = serviceUrl;
    }
}
const $870a7b5ea18ac45b$export$95c697fe95d86a77 = new $870a7b5ea18ac45b$export$68a6a391e3cf23be((0, $9qOkK.DEFAULT_CONFIG).stargateRoot);









const $359934c6a901894b$var$defaultConfig = {
    serviceUrl: `${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}/users/manage`
};
const $359934c6a901894b$var$NOT_EDITABLE = 'not_editable';
const $359934c6a901894b$var$NOT_EDITABLE_FIELD = 'field';
const $359934c6a901894b$var$NOT_EDITABLE_REASON = 'reason';
class $359934c6a901894b$export$1f387592ab3ca6d0 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async getProfileWithMutability(userId) {
        return this.getResource(`/${userId}/profile`).then((resp)=>{
            return $359934c6a901894b$var$mapToMutabilityConstraints(resp);
        });
    }
    constructor(config = {}){
        super({
            ...$359934c6a901894b$var$defaultConfig,
            ...config
        });
    }
}
function $359934c6a901894b$var$mapToMutabilityConstraints(json) {
    let constraints = [];
    if (json[$359934c6a901894b$var$NOT_EDITABLE] != null) for (const value of json[$359934c6a901894b$var$NOT_EDITABLE])constraints = constraints.concat({
        field: value[$359934c6a901894b$var$NOT_EDITABLE_FIELD],
        reason: $359934c6a901894b$var$determineReason(value[$359934c6a901894b$var$NOT_EDITABLE_REASON])
    });
    return constraints;
}
function $359934c6a901894b$var$determineReason(value) {
    switch(value){
        case 'managed':
        case 'ext.dir.scim':
        case 'ext.dir.google':
            return value;
        default:
            throw new (0, $ftJwu.DefaultError)({
                message: `Unknown mutability constraint reason: ${value}`
            });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$359934c6a901894b$export$2e2bcd8739ae039 = new $359934c6a901894b$export$1f387592ab3ca6d0();






/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $744e2dbf435f2a61$export$132d457a8475f4c8 = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}({});


const $9a7b119649650099$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case (0, $744e2dbf435f2a61$export$132d457a8475f4c8).CONFLUENCE:
            return {
                linkUrl: url,
                iconUrl: $9a7b119649650099$var$getConfluenceFavicon(url),
                productName: name
            };
        case (0, $744e2dbf435f2a61$export$132d457a8475f4c8).JIRA:
            return {
                linkUrl: url,
                iconUrl: $9a7b119649650099$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $9a7b119649650099$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $9a7b119649650099$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($9a7b119649650099$var$isIconItemSuccess).map((resp)=>resp.body.data).map($9a7b119649650099$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $9a7b119649650099$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $9a7b119649650099$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;


const $9d20303731155856$var$defaultConfig = {
    serviceUrl: `${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}`
};
class $9d20303731155856$export$a78b00aedb6cb3e9 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async getTeamLinkIcons(teamLinkUrls) {
        const requestBody = teamLinkUrls.map((url)=>({
                resourceUrl: url
            }));
        return this.postResourceRaw(`/object-resolver/resolve/batch`, JSON.stringify(requestBody)).then((0, $9a7b119649650099$export$39f4468adf4cb57c));
    }
    async getAriFromUrl(url) {
        return this.postResourceRaw(`/object-resolver/converter/toAri`, JSON.stringify({
            resourceUrl: url
        })).then((response)=>response?.data?.ari);
    }
    async getWebLinkTitle(webLinkUrl) {
        try {
            const response = await this.postResourceRaw('/object-resolver/resolve', JSON.stringify({
                resourceUrl: webLinkUrl
            }));
            if (response && 'data' in response) {
                if (response.data?.name) return response.data.name;
            }
            if (response && 'meta' in response && (response.meta?.visibility === 'restricted' || response.meta?.visibility === 'unauthorized')) {
                const auth = response.meta.auth?.[0];
                if (auth?.displayName) return auth.displayName;
            }
            return;
        } catch (error) {
            return;
        }
    }
    constructor(config = {}){
        super({
            ...$9d20303731155856$var$defaultConfig,
            ...config
        });
    }
}
var $9d20303731155856$export$2e2bcd8739ae039 = new $9d20303731155856$export$a78b00aedb6cb3e9();






class $69e0fe586c06c0c0$export$23820d8d740dd467 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    getIsSiteAdmin(/**
   * @private
   * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
   */ cloudId) {
        return this.postResource('/permitted', {
            permissionId: 'manage',
            resourceId: `ari:cloud:platform::site/${this.getCloudId(cloudId)}`
        }).then((response)=>response.permitted);
    }
}
var /**
 * REST Client to make calls to resources on the activity service.
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$69e0fe586c06c0c0$export$2e2bcd8739ae039 = new $69e0fe586c06c0c0$export$23820d8d740dd467({
    serviceUrl: (0, $9qOkK.DEFAULT_CONFIG).permsServiceUrl
});









const $560b6dca4c9da9e7$var$V1_URL = '/teams/v1';
const $560b6dca4c9da9e7$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE = [
    'TEAM_NOT_FOUND'
];
class $560b6dca4c9da9e7$export$38575d07403d67c extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async addUsersToTeam(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to add');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'addUsersToTeam');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$560b6dca4c9da9e7$var$V1_URL}/org/${orgId}/teams/${teamId}/members/add`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'addUsersToTeam');
            if (e instanceof (0, $ftJwu.HttpError) && $560b6dca4c9da9e7$var$SENTRY_IGNORED_ERROR_MESSAGES_CREATE.includes(e.message)) throw new (0, $ftJwu.SLOIgnoreHttpError)(e);
            throw e;
        }
    }
    async removeTeamMemberships(teamId, members) {
        if (!members || members.length === 0) {
            const missingMembersError = new Error('Missing members to remove');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        const membersWithIds = members.filter((member)=>!!member.accountId);
        if (membersWithIds.length !== members.length) this.logException(new Error('Missing accountIds for some members'), 'addUsersToTeam');
        if (membersWithIds.length === 0) {
            const missingMembersError = new Error('Missing accountIds for all members');
            this.logException(missingMembersError, 'removeTeamMemberships');
            throw missingMembersError;
        }
        try {
            const orgId = this.getOrgId();
            const url = `${$560b6dca4c9da9e7$var$V1_URL}/org/${orgId}/teams/${teamId}/members/remove`;
            const response = await this.postResource(url, {
                members: membersWithIds
            });
            return response;
        } catch (e) {
            this.logException(e, 'removeTeamMemberships');
            throw e;
        }
    }
    async getTeamDetails(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$560b6dca4c9da9e7$var$V1_URL}/org/${orgId}/teams/${teamId}`;
            const response = await this.getResource(url);
            return response;
        } catch (e) {
            this.logException(e, 'getTeamDetails');
            throw e;
        }
    }
    async getTeamMembers(teamId, first = 50, after) {
        try {
            const orgId = this.getOrgId();
            const url = `${$560b6dca4c9da9e7$var$V1_URL}/org/${orgId}/teams/${teamId}/members`;
            const response = await this.postResource(url, {
                after: after,
                first: first
            });
            return response;
        } catch (e) {
            this.logException(e, 'getTeamMembers');
            throw e;
        }
    }
    async restoreTeam(teamId) {
        try {
            const orgId = this.getOrgId();
            const url = `${$560b6dca4c9da9e7$var$V1_URL}/org/${orgId}/teams/${teamId}/restore`;
            return this.postResource(url);
        } catch (e) {
            this.logException(e, 'restoreTeam');
            throw e;
        }
    }
    constructor(serviceUrlRoot){
        super({
            serviceUrl: serviceUrlRoot
        });
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$560b6dca4c9da9e7$export$2e2bcd8739ae039 = new $560b6dca4c9da9e7$export$38575d07403d67c((0, $9qOkK.DEFAULT_CONFIG).publicApiRoot);






const $022a93e2f606ea82$var$defaultConfig = {
    serviceUrl: `${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}/user-tenure/v1`
};
class $022a93e2f606ea82$export$e019a6241c871c27 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async getUserTenure(userId) {
        const orgId = this.getOrgId();
        return this.getResource(`/${orgId}/${userId}`).then((response)=>({
                ...response,
                userHireDate: new Date(response.userHireDate)
            })).catch((_error)=>{
            throw new Error('Failed to fetch user tenure');
        });
    }
    constructor(config = {}){
        super({
            ...$022a93e2f606ea82$var$defaultConfig,
            ...config
        });
    }
}
var $022a93e2f606ea82$export$2e2bcd8739ae039 = new $022a93e2f606ea82$export$e019a6241c871c27();















var $6e8ccc51b4235a0a$export$2e2bcd8739ae039 = (0, $lB1H3.print)((0, $eSUdr.default)`fragment ReportingLinesUserPII on UserPII{name picture accountStatus extendedProfile{jobTitle}}fragment ReportingLinesUserFragment on ReportingLinesUser{accountIdentifier identifierType numberOfDirectReports numberOfTotalReports pii{...ReportingLinesUserPII}}query ReportingLines($aaid:String){reportingLines(aaidOrHash:$aaid){lastModifiedDate user{...ReportingLinesUserFragment}managers{...ReportingLinesUserFragment}peers{...ReportingLinesUserFragment}reports{...ReportingLinesUserFragment}}}`);


const $7974ed4bcbb0d8ee$var$SERVICE_URL = `${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}/watermelon/graphql`;
class $7974ed4bcbb0d8ee$export$59b34df773148edd extends (0, $f7f7d8f817036d9a$export$42f6d6baced34b2d) {
    async getReportingLines(userId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $6e8ccc51b4235a0a$export$2e2bcd8739ae039),
            variables: {
                aaid: userId
            }
        }, {
            operationName: 'ReportingLines'
        });
        return response;
    }
    constructor(config){
        super($7974ed4bcbb0d8ee$var$SERVICE_URL, config);
    }
}
var $7974ed4bcbb0d8ee$export$2e2bcd8739ae039 = new $7974ed4bcbb0d8ee$export$59b34df773148edd({
    logException: $iE25L.logException
});















const $9b808df65ef1ac93$export$2af9f827ad8bcf83 = (0, $lB1H3.print)((0, $eSUdr.default)`mutation addTeamWatcher($teamId:String!$cloudId:String){addTeamWatcher(input:{teamId:$teamId cloudId:$cloudId}){isWatching __typename}}`);








const $f464bbefdafcbd9c$export$5e59562b4f09e8ef = (0, $lB1H3.print)((0, $eSUdr.default)`mutation createTagForCloudId($name:String!$cloudId:String!){createTagForCloudId(input:{name:$name cloudId:$cloudId}){tag{id uuid name}}}`);








const $378b5292a0b278ea$export$a563da8c932d52b1 = (0, $lB1H3.print)((0, $eSUdr.default)`mutation CreateHelpPointer($cloudId:String!$description:String$icon:IconInput$tagUuids:[UUID]$link:String!$name:String!$teamId:String!$type:HelpPointerType!){createHelpPointer(input:{cloudId:$cloudId description:$description icon:$icon tagUuids:$tagUuids link:$link name:$name teamId:$teamId type:$type}){helpPointer{id}}}`);








const $8cccc2ce2547e34d$export$558c9434019572a1 = (0, $lB1H3.print)((0, $eSUdr.default)`mutation DeleteHelpPointer($id:ID!){deleteHelpPointer(input:{id:$id}){success}}`);








const $a6b8b80d3789d1f2$export$95b572ae48a37250 = (0, $lB1H3.print)((0, $eSUdr.default)`mutation UpdateHelpPointer($id:ID!$description:String$teamId:String$newTeamName:String$icon:IconInput$tagUuids:[UUID]$link:String$name:String$type:HelpPointerType){updateHelpPointer(input:{id:$id description:$description icon:$icon tagUuids:$tagUuids link:$link teamId:$teamId newTeamName:$newTeamName name:$name type:$type}){helpPointer{id}}}`);








const $eb3207175dcbbe42$export$fc4c702e715ad2a4 = (0, $lB1H3.print)((0, $eSUdr.default)`mutation DeleteKudos($id:ID!){deleteKudos(input:{id:$id}){success kudos{id}}}`);








const $4adda4d84650e6fe$export$d1957676c49feb6a = (0, $lB1H3.print)((0, $eSUdr.default)`mutation removeTeamWatcher($teamId:String!$cloudId:String){removeTeamWatcher(input:{teamId:$teamId cloudId:$cloudId}){isWatching __typename}}`);








const $e816b6cf8cdaf723$export$5deef0b43df462bc = (0, $lB1H3.print)((0, $eSUdr.default)`query IsTeamWatcher($teamId:String!$cloudId:String!){isTeamWatcher:teamByTeamId(teamId:$teamId cloudId:$cloudId){watching}}`);








const $6a189201414eebe9$export$2c592b5c06672873 = (0, $lB1H3.print)((0, $eSUdr.default)`query TagListByCloudId($q:String!$cloudId:String!$first:Int){tagSearchByCloudId(q:$q cloudId:$cloudId first:$first){edges{node{id uuid name projects{count}goals{count}helpLinks{count}}}}}`);


const $fdb36c3d3da4b9e4$export$ada1892306a6b676 = (baseUrl, cloudId)=>`${baseUrl}/townsquare/s/${cloudId}/graphql`;
const $fdb36c3d3da4b9e4$export$71356c4826ea823a = (baseUrl)=>`${baseUrl}/watermelon/graphql`;


class $b7c1498403091122$export$de0359e19b851166 extends (0, $f7f7d8f817036d9a$export$42f6d6baced34b2d) {
    // Team central url is a bit special, that it depends on cloudId.
    setBaseUrl(baseUrl) {
        const cloudId = this.getCloudId();
        this.setServiceUrl(cloudId && cloudId !== 'None' ? (0, $fdb36c3d3da4b9e4$export$ada1892306a6b676)(baseUrl, cloudId) : (0, $fdb36c3d3da4b9e4$export$71356c4826ea823a)(baseUrl));
    }
    async isTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $e816b6cf8cdaf723$export$5deef0b43df462bc),
            variables: {
                teamId: teamId.replace('ari:cloud:identity::team/', ''),
                cloudId: cloudId || 'None'
            }
        }, {
            operationName: 'isTeamWatcher'
        });
        return response.isTeamWatcher;
    }
    async addTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $9b808df65ef1ac93$export$2af9f827ad8bcf83),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'addTeamWatcher'
        });
        return response.addTeamWatcher;
    }
    async removeTeamWatcher(teamId, cloudId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $4adda4d84650e6fe$export$d1957676c49feb6a),
            variables: {
                teamId: teamId,
                cloudId: cloudId
            }
        }, {
            operationName: 'removeTeamWatcher'
        });
        return response.removeTeamWatcher;
    }
    async deleteKudos(id) {
        const response = await this.makeGraphQLRequest({
            query: (0, $eb3207175dcbbe42$export$fc4c702e715ad2a4),
            variables: {
                id: id
            }
        }, {
            operationName: 'DeleteKudos'
        });
        return response.deleteKudos;
    }
    async queryTagList(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $6a189201414eebe9$export$2c592b5c06672873),
            variables: variables
        }, {
            operationName: 'TagListByCloudId'
        });
        return response.tagSearchByCloudId;
    }
    async createTag(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $f464bbefdafcbd9c$export$5e59562b4f09e8ef),
            variables: variables
        }, {
            operationName: 'createTagForCloudId'
        });
        return response.createTagForCloudId;
    }
    async createHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $378b5292a0b278ea$export$a563da8c932d52b1),
            variables: variables
        }, {
            operationName: 'CreateHelpPointer'
        });
        return response.createHelpPointer;
    }
    async updateHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $a6b8b80d3789d1f2$export$95b572ae48a37250),
            variables: variables
        }, {
            operationName: 'UpdateHelpPointer'
        });
        return response.updateHelpPointer;
    }
    async deleteHelpPointer(variables) {
        const response = await this.makeGraphQLRequest({
            query: (0, $8cccc2ce2547e34d$export$558c9434019572a1),
            variables: variables
        }, {
            operationName: 'DeleteHelpPointer'
        });
        return response.deleteHelpPointer;
    }
    constructor(baseUrl, config){
        super((0, $fdb36c3d3da4b9e4$export$71356c4826ea823a)(baseUrl), config);
    }
}
var $b7c1498403091122$export$2e2bcd8739ae039 = new $b7c1498403091122$export$de0359e19b851166((0, $9qOkK.DEFAULT_CONFIG).stargateRoot, {
    logException: $iE25L.logException
});






const $51a7519394ea0948$var$defaultConfig = {
    serviceUrl: `${(0, $9qOkK.DEFAULT_CONFIG).stargateRoot}/teamsslack/api/team`
};
class $51a7519394ea0948$export$9509cbc6b0605446 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async getTeamInSlack(teamId, teamName) {
        return this.getResource(`/${teamId}?teamName=${encodeURIComponent(teamName)}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async disconnectTeamInSlack(teamId) {
        return this.deleteResource(`/${teamId}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    async updateTeamInSlack(teamId, channelId, usergroupHandle) {
        return this.postResource(`/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`).then((response)=>({
                id: teamId,
                ...response
            }));
    }
    constructor(config = {}){
        super({
            ...$51a7519394ea0948$var$defaultConfig,
            ...config
        });
    }
}
var $51a7519394ea0948$export$2e2bcd8739ae039 = new $51a7519394ea0948$export$9509cbc6b0605446();






const $c14f39264c0c070c$var$buildGetReadTokenURL = (accountId)=>`/api/user-image/${accountId}/header-image/read`;
class $c14f39264c0c070c$export$3c27e20d1b94924 extends (0, $d4429adef1b89b84$export$ea8b5b3aea9558ce) {
    async getReadMediaToken(accountId) {
        return this.getResource($c14f39264c0c070c$var$buildGetReadTokenURL(accountId)).then((response)=>response);
    }
    async getWriteMediaToken() {
        return this.getResource('/api/user-image/header-image/write').then((response)=>response);
    }
    async updateUserHeaderImage(headerImageId) {
        return await this.putResource('/api/user-image/self/header-image', {
            headerImageId: headerImageId
        });
    }
}
var $c14f39264c0c070c$export$2e2bcd8739ae039 = new $c14f39264c0c070c$export$3c27e20d1b94924({
    serviceUrl: (0, $9qOkK.DEFAULT_CONFIG).stargateRoot
});


class $e08858dab7256022$export$db59823f35bf78ce {
    async measurePerformance(name, fn) {
        const exp = (0, $dc5c4228ac2d2b6c$export$879344107b04120c).get(name);
        if (!exp) return fn();
        exp.start();
        try {
            const result = await fn();
            exp.success();
            return result;
        } catch (e) {
            exp.failWithError(e);
            throw e;
        }
    }
    /**
   * Sets the base URL to be used in the client requests
   * @param {string} baseUrl - The new base URL
   */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
        this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
   * Sets context including CloudId & OrgId to be used for all requests
   */ setContext(context) {
        this._aggClient.setContext(context);
        this._directoryClient.setContext(context);
        this._legionClient.setContext(context);
        this._permsClient.setContext(context);
        this._mutabilityClient.setContext(context);
        this._publicApiClient.setContext(context);
        this._invitationsClient.setContext(context);
        this._replinesClient.setContext(context);
    }
    setTeamCentralContext(baseUrl, context) {
        this._teamCentralClient.setContext(context);
        this._teamCentralClient.setBaseUrl(baseUrl);
    }
    /**
   * @private
   * @deprecated use setBaseUrl instead
   */ setDirectoryBaseUrl(baseUrl) {
        // eslint-disable-next-line no-console
        console.warn('setDirectoryBaseUrl is deprecated, use setBaseUrl instead');
        return this._directoryClient.setBaseUrl(baseUrl);
    }
    /**
   * Fetches Browse user settings
   */ async querySettings(cloudId, product) {
        if (cloudId) {
            if ((0, $dh538.fg)('fix_query_settings_context')) {
                const previousContext = this._legionClient.getContext();
                this.setContext({
                    ...previousContext,
                    cloudId: cloudId
                });
            } else this.setContext({
                cloudId: cloudId
            });
        }
        return this.measurePerformance('querySettings', async ()=>{
            if (!product) throw new Error('Product is required');
            const response = await this._legionClient.retrieveBrowseUserPermission(product);
            return {
                'internal.browse-users-allowed': response.canSearchUsers
            };
        });
    }
    /**
   * This will return all of the teams-related permissions that your user has for the org and site in the client context.
   */ async getPermissions() {
        return this.measurePerformance('getPermissions', ()=>this._legionClient.getPermissions());
    }
    /**
   * Fetches feature flags from Directory
   * @deprecated As part of decommisioning pf-directoy
   */ async queryFeatureFlags(...args) {
        return this.measurePerformance('queryFeatureFlags', ()=>this._directoryClient.queryFeatureFlags(...args));
    }
    /**
   * Get user information of members of a team, paginated
   * @param {string} teamId
   * @returns {Promise}
   */ async queryTeamMemberships(teamId, membershipState = [
        'FULL_MEMBER'
    ], pageInfo = {
        first: 100
    }) {
        return this._aggClient.queryTeamMemberships(teamId, membershipState, pageInfo);
    }
    /**
   * Get user information given an user id
   * @param {string} userId
   * @returns {Promise}
   */ async queryAGGUser(userId) {
        return this._aggClient.queryAGGUser(userId);
    }
    /**
   * Get the agents associated with the team
   * @param {string} userId
   * @returns {Promise}
   */ async queryTeamHasAgents(teamId) {
        return this._aggClient.queryTeamHasAgents(teamId);
    }
    /**
   * Get containers associated with the team
   * @param {string} teamId
   * @returns {Promise<TeamContainers>}
   */ async getTeamContainers(teamId) {
        return this._aggClient.getTeamContainers(teamId);
    }
    /**
   * Unlink a container from a team
   * @param {string} teamId
   * @param {string} containerId
   * @returns {Promise}
   */ async unlinkTeamContainer(teamId, containerId) {
        return this._aggClient.unlinkTeamContainer(teamId, containerId);
    }
    /**
   * Get the number of teams connected to a container
   * @param {string} containerId
   * @returns {Promise<number>}
   */ async queryNumberOfTeamConnectedToContainer(containerId) {
        return this._aggClient.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
   * Get the number of teams connected to a container (Confluence space or Jira project)
   * @param {string} containerId
   * @returns {Promise<number>}
   */ async getNumberOfConnectedTeams(containerId) {
        return this.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
   * Get teams connected to a container
   * @param {string} containerId
   * @returns {Promise<TeamWithMemberships[]>}
   */ async queryTeamsConnectedToContainer(containerId) {
        return this._aggClient.queryTeamsConnectedToContainer(containerId);
    }
    /**
   * Get teams connected to a container (Confluence space or Jira project)
   * @param {string} containerId
   * @returns {Promise<TeamWithMemberships[]>}
   */ async getConnectedTeams(containerId) {
        return this.queryTeamsConnectedToContainer(containerId);
    }
    /**
   * Get user information of a member of a team
   * @param {string} userId
   * @returns {Promise<CloudUser>}
   */ queryUser(...args) {
        return this.measurePerformance('queryUser', ()=>this._directoryClient.queryUser(...args));
    }
    setLegionRootUrl(url) {
        return this._legionClient.setRootUrl(url);
    }
    /**
   *
   * @param teamId
   * @returns {Promise<TeamWithImageUrls>}
   */ async getTeamById(teamId, cloudId) {
        return this.measurePerformance('getTeamById', ()=>this._legionClient.getTeamById(teamId, cloudId));
    }
    /**
   * Search teams based on query
   */ async getAllTeams(...args) {
        return this.measurePerformance('getAllTeams', ()=>this._legionClient.getAllTeams(...args));
    }
    /**
   * Update team details
   */ async updateTeamById(...args) {
        return this.measurePerformance('updateTeamById', ()=>this._legionClient.updateTeamById(...args));
    }
    /**
   * @private
   * @deprecated use addUsersToTeam instead
   */ async inviteUsersToTeam(...args) {
        return this.measurePerformance('inviteUsersToTeam', ()=>this._legionClient.inviteUsersToTeam(...args));
    }
    /**
   * Get the current user's team membership
   */ async getMyTeamMembership(...args) {
        return this.measurePerformance('getMyTeamMembership', ()=>this._legionClient.getMyTeamMembership(...args));
    }
    /**
   * Get a teams "Links"
   */ async getTeamLinksByTeamId(teamId) {
        return this.measurePerformance('getTeamLinksByTeamId', ()=>this._legionClient.getTeamLinksByTeamId(teamId));
    }
    /**
   * Create a team link
   */ async createTeamLink(...args) {
        return this.measurePerformance('createTeamLink', ()=>this._legionClient.createTeamLink(...args));
    }
    /**
   * Update a team link
   */ async updateTeamLink(...args) {
        return this.measurePerformance('updateTeamLink', ()=>this._legionClient.updateTeamLink(...args));
    }
    /**
   * Delete a team link
   */ async deleteTeamLink(...args) {
        return this.measurePerformance('deleteTeamLink', ()=>this._legionClient.deleteTeamLink(...args));
    }
    /**
   * Reorder a team link
   */ async reorderTeamLink(...args) {
        return this.measurePerformance('reorderTeamLink', ()=>this._legionClient.reorderTeamLink(...args));
    }
    /**
   * Get org's eligibility for managed teams
   */ async getOrgEligibilityForManagedTeams() {
        return this.measurePerformance('getOrgEligibilityForManagedTeams', ()=>this._legionClient.getOrgEligibilityForManagedTeams());
    }
    /**
   * @deprecated Invitation status no longer exists
   * Accept a team invitation
   */ async acceptTeamInvitation(...args) {
        return this.measurePerformance('acceptTeamInvitation', ()=>this._legionClient.acceptTeamInvitation(...args));
    }
    /**
   * @deprecated Invitation status no longer exists
   * Decline a team invitation
   */ async declineTeamInvitation(...args) {
        return this.measurePerformance('declineTeamInvitation', ()=>this._legionClient.declineTeamInvitation(...args));
    }
    /**
   * Add current user to a team
   */ async selfJoinTeam(...args) {
        return this.measurePerformance('selfJoinTeam', ()=>this._legionClient.selfJoinTeam(...args));
    }
    /**
   * Add agent to a team
   */ async addAgentsToTeam(...args) {
        return this.measurePerformance('addAgentToTeam', ()=>this._legionClient.addAgentsToTeam(...args));
    }
    async removeAgentTeamAssociation(...args) {
        return this.measurePerformance('removeAgentTeamAssociation', ()=>this._legionClient.removeAgentTeamAssociation(...args));
    }
    /**
   * Cancel a join request to a private team
   */ async cancelJoinRequest(teamId) {
        return this.measurePerformance('cancelJoinRequest', ()=>this._legionClient.cancelJoinRequest(teamId));
    }
    /**
   * Accept a join request to a private team
   */ async acceptJoinRequest(...args) {
        return this.measurePerformance('acceptJoinRequest', ()=>this._legionClient.acceptJoinRequest(...args));
    }
    /**
   * Decline a join request to a private team
   */ async declineJoinRequest(...args) {
        return this.measurePerformance('declineJoinRequest', ()=>this._legionClient.declineJoinRequest(...args));
    }
    /**
   * @deprecated use removeTeamMemberships instead
   */ async deleteTeamMembership(...args) {
        return this.measurePerformance('deleteTeamMembership', ()=>this._legionClient.deleteTeamMembership(...args));
    }
    /**
   * @deprecated INVITED status has been deprecated
   */ async revokeTeamInvite(...args) {
        return this.measurePerformance('revokeTeamInvite', ()=>this._legionClient.revokeTeamInvite(...args));
    }
    /**
   * Delete a team
   */ async deleteTeam(teamId) {
        return this.measurePerformance('deleteTeam', ()=>this._legionClient.deleteTeam(teamId));
    }
    /**
   * Archive a team
   */ async archiveTeam(teamId) {
        return this.measurePerformance('archiveTeam', ()=>this._legionClient.archiveTeam(teamId));
    }
    /**
   * Unarchive a team
   */ async unarchiveTeam(teamId) {
        return this.measurePerformance('unarchiveTeam', ()=>this._legionClient.unArchiveTeam(teamId));
    }
    /**
   * Unlink a team from group
   */ async unlinkTeamFromGroup(teamId) {
        return this.measurePerformance('unlinkTeamFromGroup', ()=>this._legionClient.unlinkTeamFromGroup(teamId, 'MEMBER_INVITE'));
    }
    /**
   * @private
   * @deprecated should be other means to solve this issue
   */ async isSingleFullMemberTeam(teamId) {
        return this._legionClient.isSingleFullMemberTeam(teamId);
    }
    /**
   * Create a team
   */ async createTeam(...args) {
        return this.measurePerformance('createTeam', ()=>this._legionClient.createTeam(...args));
    }
    /**
   * Create containers for a team
   */ async createTeamContainers(...args) {
        return this.measurePerformance('createTeamContainers', ()=>this._legionClient.createTeamContainers(...args));
    }
    /**
   * Create a external team
   * @param {string} groupDescription - The description of the group, which will be used as the team description. The group name will be fetched from the identity service, so it does not need to be provided.
   * @param {ExternalReference} externalReference
   */ async createExternalTeam(...args) {
        return this.measurePerformance('createExternalTeam', ()=>this._legionClient.createExternalTeam(...args));
    }
    /**
   * Get linked teams for a groups in bulk
   * @param {string} groupIds - The group ids to fetch linked teams for
   */ async getLinkedTeamsBulk(...args) {
        return this.measurePerformance('getLinkedTeamsBulk', ()=>this._legionClient.getLinkedTeamsBulk(...args));
    }
    /**
   * Get Org scope
   */ async getOrgScope(...args) {
        return this.measurePerformance('getOrgScope', ()=>this._legionClient.getOrgScope(...args));
    }
    /**
   * Restore soft-deleted team and sync to group
   */ async restoreTeamToSyncedGroup(...args) {
        return this.measurePerformance('restoreTeamToSyncedGroup', ()=>this._legionClient.restoreTeamToSyncedGroup(...args));
    }
    /**
   * Get the difference between a team and a group
   * @param teamId
   * @param {ExternalReference} externalReference
   * @returns {Promise<TeamAndGroupDifference>}
   */ async getTeamAndGroupDiff(...args) {
        return this.measurePerformance('getTeamAndGroupDiff', ()=>this._legionClient.getTeamAndGroupDiff(...args));
    }
    /**
   * Link an existing team to a group
   * @param teamId
   * @param {ExternalReference} externalReference
   */ async linkExistingTeamToGroup(...args) {
        return this.measurePerformance('linkExistingTeamToGroup', ()=>this._legionClient.linkExistingTeamToGroup(...args));
    }
    /**
   *
   * @param teamId
   * @returns {Promise<LinkedTeamsProfileDetails>}
   */ async getTeamProfileDetailsByTeamId(...args) {
        return this.measurePerformance('getTeamProfileDetails', ()=>this._legionClient.getTeamProfileDetails(...args));
    }
    /**
   *
   * @param teamId
   * @returns {Promise<SoftDeletedTeam>}
   */ async getSoftDeletdTeamById(teamId) {
        return this.measurePerformance('getSoftDeletedTeamById', ()=>this._legionClient.getSoftDeletedTeamById(teamId));
    }
    /**
   * Shoud only be used within Teams (P&T) packages
   * @param userId
   * @returns {Promise<SoftDeletedTeam>}
   */ async getUserInSiteUserBase(userId) {
        return this.measurePerformance('getUserInSiteUserBase', ()=>this._legionClient.getUserInSiteUserBase(userId));
    }
    trimTeamARI(teamId = '') {
        return this._legionClient.trimTeamARI(teamId);
    }
    /**
   * Get user profile with mutability constraints
   */ async getProfileWithMutability(...args) {
        return this.measurePerformance('getProfileWithMutability', ()=>this._mutabilityClient.getProfileWithMutability(...args));
    }
    /**
   * Get enabled sites for a team
   */ async getTeamEnabledSites(...args) {
        return this.measurePerformance('getTeamEnabledSites', ()=>this._legionClient.getTeamEnabledSites(...args));
    }
    /**
   * Assign teams to sites
   * @param migrations
   * @returns {Promise<AssignTeamsToSitesResponse>}
   */ async assignTeamsToSites(...args) {
        return this.measurePerformance('assignTeamsToSites', ()=>this._legionClient.assignTeamsToSites(...args));
    }
    /**
   * Get assigned teams
   * @param orgId
   * @param cursor
   * @param displayNameContains
   * @param count - number of teams to return
   */ async getAssignedTeams(...args) {
        return this.measurePerformance('getAssignedTeams', ()=>this._legionClient.getAssignedTeams(...args));
    }
    /**
   * Get unassigned teams
   * @param orgId
   * @param count - number of teams to return
   * @param cursor - cursor to the next page of results
   * @param query - query to filter teams by
   */ async getUnassignedTeams(...args) {
        return this.measurePerformance('getUnassignedTeams', ()=>this._legionClient.getUnassignedTeams(...args));
    }
    /**
   * Set team site assignment permission
   * @param orgId
   * @param alignmentPermission - 'ALL_USERS' | 'ORG_ADMIN'
   */ async setTeamSiteAssignmentPermission(...args) {
        return this.measurePerformance('setTeamSiteAssignmentPermission', ()=>this._legionClient.setTeamSiteAssignmentPermission(...args));
    }
    /**
   * Get team site assignment org details
   */ async getTeamSiteAssignmentOrgDetails(...args) {
        return this.measurePerformance('getTeamSiteAssignmentOrgDetails', ()=>this._legionClient.getTeamSiteAssignmentOrgDetails(...args));
    }
    /**
   * Get teams to be cloned to JSM sites
   */ async getTeamsToBeClonedToJsmSites(...args) {
        return this.measurePerformance('getTeamsToBeClonedToJsmSites', ()=>this._legionClient.getTeamsToBeClonedToJsmSites(...args));
    }
    /**
   * Is the current user a site admin
   */ getIsSiteAdmin(...args) {
        return this.measurePerformance('getIsSiteAdmin', ()=>this._permsClient.getIsSiteAdmin(...args));
    }
    /**
   * Add users to a team
   */ addUsersToTeam(...args) {
        return this.measurePerformance('addUsersToTeam', ()=>this._publicApiClient.addUsersToTeam(...args));
    }
    /**
   * Remove users from a team
   */ removeTeamMemberships(...args) {
        return this.measurePerformance('removeTeamMemberships', ()=>this._publicApiClient.removeTeamMemberships(...args));
    }
    /**
   * Restore a deleted team
   */ restoreTeam(...args) {
        return this.measurePerformance('restoreTeam', ()=>this._publicApiClient.restoreTeam(...args));
    }
    getRecommendedProducts(...args) {
        return this.measurePerformance('getRecommendedProducts', ()=>this._invitationsClient.getProductRecommendations(...args));
    }
    joinOrRequestDefaultAccessToProductsBulk(...args) {
        return this.measurePerformance('joinOrRequestDefaultAccessToProductsBulk', ()=>this._invitationsClient.joinOrRequestDefaultAccessToProductsBulk(...args));
    }
    /**
   * Get token to upload media for a team
   */ async getWriteTeamMediaToken() {
        return this.measurePerformance('getWriteTeamMediaToken', ()=>this._legionClient.getWriteMediaToken());
    }
    /**
   * Get token to read media for a user
   */ async getReadMediaToken(...args) {
        return this.measurePerformance('getReadMediaToken', ()=>this._userPreferencesClient.getReadMediaToken(...args));
    }
    /**
   * Get token to upload media for a user
   */ async getWriteUserMediaToken() {
        return this.measurePerformance('getWriteUserMediaToken', ()=>this._userPreferencesClient.getWriteMediaToken());
    }
    /**
   * Update header image for a user
   */ async updateUserHeaderImage(headerImageId) {
        return this.measurePerformance('updateUserHeaderImage', ()=>this._userPreferencesClient.updateUserHeaderImage(headerImageId));
    }
    /**
   * Fetch user containers from collboration graph
   */ async getUserContainers(...args) {
        return this.measurePerformance('getUserContainers', ()=>this._collaborationGraphClient.getUserContainers(...args));
    }
    /**
   * Fetch recommended users from collaboration graph
   */ async getRecommendedUsers(...args) {
        return this.measurePerformance('getRecommendedUsers', ()=>this._collaborationGraphClient.getRecommendedUsers(...args));
    }
    /**
   * Fetch mutatability of external managed user fields
   */ async getUserManageConfig(...args) {
        return this.measurePerformance('getUserManageConfig', ()=>this._identityClient.getUserManageConfig(...args));
    }
    /**
   * Fetch user avatar uploaded status
   */ async getMyAvatarUploadedStatus(...args) {
        return this.measurePerformance('getMyAvatarUploadedStatus', ()=>this._identityClient.getMyAvatarUploadedStatus(...args));
    }
    /**
   * Delete user avatar
   */ async deleteAvatar(...args) {
        return this.measurePerformance('deleteUserAvatar', ()=>this._identityClient.deleteAvatar(...args));
    }
    async fetchUserAvatarInfo(...args) {
        return this.measurePerformance('fetchUserAvatarInfo', ()=>this._identityClient.fetchUserAvatarInfo(...args));
    }
    /**
   * Fetch Team link icons
   */ async getTeamLinkIcons(...args) {
        return this.measurePerformance('getTeamLinkIcons', ()=>this._objectResolverClient.getTeamLinkIcons(...args));
    }
    /**
   * Fetch ARI from URL
   */ async getAriFromUrl(...args) {
        return this.measurePerformance('getAriFromUrl', ()=>this._objectResolverClient.getAriFromUrl(...args));
    }
    /**
   * Fetch web link title
   */ async getWebLinkTitle(...args) {
        return this.measurePerformance('getWebLinkTitle', ()=>this._objectResolverClient.getWebLinkTitle(...args));
    }
    /**
   * Fetch team in slack details
   */ async getTeamInSlack(...args) {
        return this.measurePerformance('getTeamInSlack', ()=>this._teamsInSlackClient.getTeamInSlack(...args));
    }
    /**
   * Delete team in slack
   */ async disconnectTeamInSlack(...args) {
        return this.measurePerformance('disconnectTeamInSlack', ()=>this._teamsInSlackClient.disconnectTeamInSlack(...args));
    }
    /**
   * Update team in slack
   */ async updateTeamInSlack(...args) {
        return this.measurePerformance('updateTeamInSlack', ()=>this._teamsInSlackClient.updateTeamInSlack(...args));
    }
    /**
   * Update user details
   */ async updateUser(...args) {
        return this.measurePerformance('updateUser', ()=>this._identityClient.updateUser(...args));
    }
    async updateUserAvatar(...args) {
        return this.measurePerformance('updateUserAvatar', ()=>this._identityClient.updateUserAvatar(...args));
    }
    async addTeamWatcher(...args) {
        return this._teamCentralClient.addTeamWatcher(...args);
    }
    async isTeamWatcher(...args) {
        return this._teamCentralClient.isTeamWatcher(...args);
    }
    async removeTeamWatcher(...args) {
        return this._teamCentralClient.removeTeamWatcher(...args);
    }
    async deleteKudos(...args) {
        return this._teamCentralClient.deleteKudos(...args);
    }
    async queryTagList(...args) {
        return this._teamCentralClient.queryTagList(...args);
    }
    async createTag(...args) {
        return this._teamCentralClient.createTag(...args);
    }
    async createHelpPointer(...args) {
        return this._teamCentralClient.createHelpPointer(...args);
    }
    async updateHelpPointer(...args) {
        return this._teamCentralClient.updateHelpPointer(...args);
    }
    async deleteHelpPointer(...args) {
        return this._teamCentralClient.deleteHelpPointer(...args);
    }
    async getUserTenure(...args) {
        return this.measurePerformance('getUserTenure', ()=>this._replinesClient.getUserTenure(...args));
    }
    async checkOrgFullAlignmentStatus(...args) {
        return this._legionClient.checkOrgFullAlignmentStatus(...args);
    }
    async getTeamStatesInBulk(...args) {
        return this._legionClient.getTeamStatesInBulk(...args);
    }
    async getReportingLines(...args) {
        return this.measurePerformance('getReportingLines', ()=>this._reportingLinesClient.getReportingLines(...args));
    }
    constructor(/**
   * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
   */ context){
        this._aggClient = (0, $2e8ee8ab2bb7f77a$export$464c991dbf0b2393);
        this._directoryClient = (0, $fecffb0f2c6ffe55$export$ead519165de472de);
        this._legionClient = (0, $870a7b5ea18ac45b$export$95c697fe95d86a77);
        this._mutabilityClient = (0, $359934c6a901894b$export$2e2bcd8739ae039);
        this._permsClient = (0, $69e0fe586c06c0c0$export$2e2bcd8739ae039);
        this._publicApiClient = (0, $560b6dca4c9da9e7$export$2e2bcd8739ae039);
        this._invitationsClient = (0, $87f3561bb905741b$export$2e2bcd8739ae039);
        this._userPreferencesClient = (0, $c14f39264c0c070c$export$2e2bcd8739ae039);
        this._objectResolverClient = (0, $9d20303731155856$export$2e2bcd8739ae039);
        this._teamsInSlackClient = (0, $51a7519394ea0948$export$2e2bcd8739ae039);
        this._collaborationGraphClient = (0, $bba3dd522b653c17$export$2e2bcd8739ae039);
        this._identityClient = (0, $c928023e423fd9b8$export$2e2bcd8739ae039);
        this._teamCentralClient = (0, $b7c1498403091122$export$2e2bcd8739ae039);
        this._replinesClient = (0, $022a93e2f606ea82$export$2e2bcd8739ae039);
        this._reportingLinesClient = (0, $7974ed4bcbb0d8ee$export$2e2bcd8739ae039);
        if (context) this.setContext(context);
    }
}
const $e08858dab7256022$export$5ed932c3646b89c6 = new $e08858dab7256022$export$db59823f35bf78ce();
module.exports["teamsClient"] = $e08858dab7256022$export$5ed932c3646b89c6;

});

parcelRegister("4VXWT", function(module, exports) {

var $4SCyD = parcelRequire("4SCyD");


var $ftJwu = parcelRequire("ftJwu");




const $f50019e2255c9968$export$7286a0fb7b5aab6b = (error)=>({
        error: {
            name: error.name,
            message: error.message,
            stack: error.stack,
            traceId: error instanceof (0, $ftJwu.HttpError) ? error.traceId : undefined,
            status: error instanceof (0, $ftJwu.HttpError) ? error.status : undefined
        }
    });
const $f50019e2255c9968$var$ignoredErrors = [
    'SLOIgnoreError',
    'SLOIgnoreHttpError'
];
const $f50019e2255c9968$export$a8da197a8bcc7e95 = (error)=>{
    const errorName = error?.constructor.name;
    if (!errorName) return false;
    return $f50019e2255c9968$var$ignoredErrors.includes(errorName);
};


class $78b753f5fb5081de$export$9a18529d1e90e81a extends (0, $4SCyD.UFOExperience) {
    abortWithError(error, reason) {
        return super.abort({
            metadata: {
                error: (0, $f50019e2255c9968$export$7286a0fb7b5aab6b)(error),
                reason: reason
            }
        });
    }
    failWithError(error) {
        if (error instanceof Error) {
            if ((0, $ftJwu.isAuthError)(error)) return this.abortWithError(error, 'Abort due to user unauthenticated');
            if ((0, $ftJwu.isErrorStatusCode)((0, $ftJwu.StatusCode).GONE, error)) return this.abortWithError(error, 'Abort due to unavailable resource');
            if ((0, $f50019e2255c9968$export$a8da197a8bcc7e95)(error)) return this.abortWithError(error, 'Abort due to an error in ignore list');
            if ((0, $ftJwu.isNetworkError)(error)) return this.abortWithError(error, 'Abort due to network error');
            return super.failure({
                metadata: {
                    error: (0, $f50019e2255c9968$export$7286a0fb7b5aab6b)(error),
                    packageVersion: "0.0.0-use.local",
                    packageName: "platform-pkg"
                }
            });
        }
        return super.failure({
            metadata: {
                error: 'unknown error',
                packageVersion: "0.0.0-use.local",
                packageName: "platform-pkg"
            }
        });
    }
}
module.exports["TeamsUFOExperience"] = $78b753f5fb5081de$export$9a18529d1e90e81a;

});

parcelRegister("ftJwu", function(module, exports) {
var $ee9b270906e6a5a4$var$_GraphQLError;
var $ee9b270906e6a5a4$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $ee9b270906e6a5a4$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $ee9b270906e6a5a4$export$cde1786a482f9a1c(error) {
    return $ee9b270906e6a5a4$export$9677d7c364ada66c(401, error) || $ee9b270906e6a5a4$export$9677d7c364ada66c(403, error);
}
function $ee9b270906e6a5a4$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $ee9b270906e6a5a4$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $ee9b270906e6a5a4$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $ee9b270906e6a5a4$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.message = void 0;
        this.name = void 0;
        this.stack = void 0;
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $ee9b270906e6a5a4$export$c73ca302efeda3b4 extends $ee9b270906e6a5a4$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $ee9b270906e6a5a4$export$c73ca302efeda3b4.prototype);
    }
}
class $ee9b270906e6a5a4$export$d87f401f8106d7a2 extends $ee9b270906e6a5a4$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $ee9b270906e6a5a4$export$d87f401f8106d7a2.prototype);
    }
}
class $ee9b270906e6a5a4$export$65bd6083489bd8bb extends $ee9b270906e6a5a4$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        this.status = void 0;
        this.traceId = void 0;
        this.path = void 0;
        Object.setPrototypeOf(this, $ee9b270906e6a5a4$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $ee9b270906e6a5a4$export$826a3d65b8435adf extends $ee9b270906e6a5a4$export$65bd6083489bd8bb {
    constructor(props){
        super(props);
        Object.setPrototypeOf(this, $ee9b270906e6a5a4$export$826a3d65b8435adf.prototype);
    }
}
class $ee9b270906e6a5a4$export$92d6ed0888e7cb7f extends $ee9b270906e6a5a4$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        this.fields = void 0;
        // tslint:disable-line no-any
        this.category = void 0;
        Object.setPrototypeOf(this, $ee9b270906e6a5a4$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
}
$ee9b270906e6a5a4$var$_GraphQLError = $ee9b270906e6a5a4$export$92d6ed0888e7cb7f;
$ee9b270906e6a5a4$export$92d6ed0888e7cb7f.from = (rawErrors)=>{
    const firstError = rawErrors[0];
    const errorData = {
        category: firstError.category,
        message: firstError.message
    };
    if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
        obj[item.field] = item.message;
        return obj;
    }, {});
    return new $ee9b270906e6a5a4$var$_GraphQLError(errorData);
};
function $ee9b270906e6a5a4$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
module.exports["StatusCode"] = $ee9b270906e6a5a4$export$f66f92b8741acd5b;
module.exports["isAuthError"] = $ee9b270906e6a5a4$export$cde1786a482f9a1c;
module.exports["isErrorStatusCode"] = $ee9b270906e6a5a4$export$9677d7c364ada66c;
module.exports["DefaultError"] = $ee9b270906e6a5a4$export$c73ca302efeda3b4;
module.exports["SLOIgnoreError"] = $ee9b270906e6a5a4$export$d87f401f8106d7a2;
module.exports["HttpError"] = $ee9b270906e6a5a4$export$65bd6083489bd8bb;
module.exports["SLOIgnoreHttpError"] = $ee9b270906e6a5a4$export$826a3d65b8435adf;
module.exports["GraphQLError"] = $ee9b270906e6a5a4$export$92d6ed0888e7cb7f;
module.exports["isNetworkError"] = $ee9b270906e6a5a4$export$476aa014e2fd89d5;

});

parcelRegister("cFYtL", function(module, exports) {
const $1458c01e14a166cd$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $1458c01e14a166cd$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';


const $97bd0862e8ff49f3$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $1458c01e14a166cd$export$470b0d72e4fdc43a));
const $97bd0862e8ff49f3$export$1d0eef1d33b05366 = (ari)=>{
    if ($97bd0862e8ff49f3$export$caac29844ad91f64(ari)) return ari.replace((0, $1458c01e14a166cd$export$470b0d72e4fdc43a), '');
    throw new Error('Invalid UserARI');
};
const $97bd0862e8ff49f3$export$fca6a88adb58674a = (userId)=>{
    return $97bd0862e8ff49f3$export$caac29844ad91f64(userId) ? userId : `${0, $1458c01e14a166cd$export$470b0d72e4fdc43a}${userId}`;
};
const $97bd0862e8ff49f3$export$7b81d5dfd83c8166 = (ari)=>ari.startsWith((0, $1458c01e14a166cd$export$cfedc369802e0c68));
const $97bd0862e8ff49f3$export$e78216c959b9f3af = (ari)=>{
    if ($97bd0862e8ff49f3$export$7b81d5dfd83c8166(ari)) return ari.replace((0, $1458c01e14a166cd$export$cfedc369802e0c68), '');
    throw new Error('Invalid TeamARI');
};
const $97bd0862e8ff49f3$export$2bcc6e4924859c6f = (teamId)=>{
    return $97bd0862e8ff49f3$export$7b81d5dfd83c8166(teamId) ? teamId : `${0, $1458c01e14a166cd$export$cfedc369802e0c68}${teamId}`;
};
module.exports["toUserId"] = $97bd0862e8ff49f3$export$1d0eef1d33b05366;
module.exports["toUserARI"] = $97bd0862e8ff49f3$export$fca6a88adb58674a;
module.exports["toTeamId"] = $97bd0862e8ff49f3$export$e78216c959b9f3af;
module.exports["toTeamARI"] = $97bd0862e8ff49f3$export$2bcc6e4924859c6f;

});

parcelRegister("9qOkK", function(module, exports) {
const $83a10e212a833312$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api',
    permsServiceUrl: '/gateway/api/permissions',
    publicApiRoot: '/gateway/api/public',
    invitationsServiceUrl: '/gateway/api/invitations',
    collaborationGraphUrl: '/gateway/api/collaboration'
};
module.exports["DEFAULT_CONFIG"] = $83a10e212a833312$export$c2f8e0cc249a8d8f;

});

parcelRegister("aR5ht", function(module, exports) {
const $ba982387d3390539$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $ba982387d3390539$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $ba982387d3390539$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $ba982387d3390539$var$defaultRetryIfCallback = (a)=>!a;
const $ba982387d3390539$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $ba982387d3390539$var$defaultRetryIfCallback
};
function $ba982387d3390539$export$20eaa22f2295996f(toTry, hofOptions = $ba982387d3390539$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $ba982387d3390539$export$b4c0bf5325504bf3 = $ba982387d3390539$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $ba982387d3390539$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $ba982387d3390539$export$8f4286bf21155381.JITTER,
    max: $ba982387d3390539$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$ba982387d3390539$export$55b2fbd5d4a32495(response.status)
});
module.exports["EXPONENTIAL_BACKOFF_RETRY_POLICY"] = $ba982387d3390539$export$8f4286bf21155381;
module.exports["is5xx"] = $ba982387d3390539$export$55b2fbd5d4a32495;
module.exports["isFetchResponse"] = $ba982387d3390539$export$81f27058be86d7ea;
module.exports["withExponentialBackoff"] = $ba982387d3390539$export$20eaa22f2295996f;
module.exports["fetchWithExponentialBackoff"] = $ba982387d3390539$export$b4c0bf5325504bf3;

});


//# sourceMappingURL=ProjectPanel.f12f9a2c.js.map
